IREP.futbolStates = (function () {
    var states = {
        preGame: {
            moves: {
                defenseLeftBack: { x: -1075, y: -950 },
                defenseLeftCenterBack: { x: -1075, y: -850 },
                defenseRightCenterBack: { x: -1075, y: 425 },
                defenseRightBack: { x: -1075, y: 725 },
                defenseLeftMidfield: { x: -1075, y: -1250 },
                defenseLeftCenterMidfield: { x: -1075, y: -1050 },
                defenseRightCenterMidfield: { x: -1075, y: 225 },
                defenseRightMidfield: { x: -1075, y: 525 },
                defenseLeftForward: { x: -1075, y: -1150 },
                defenseRightForward: { x: -1075, y: 925 },
                offenseRightBack: { x: 1050, y: -1250 },
                offenseRightCenterBack: { x: 1050, y: -850 },
                offenseLeftCenterBack: { x: 1050, y: 525 },
                offenseLeftBack: { x: 1050, y: 925 },
                offenseRightMidfield: { x: 1050, y: -1150 },
                offenseRightCenterMidfield: { x: 1050, y: -1050 },
                offenseLeftCenterMidfield: { x: 1050, y: 425 },
                offenseLeftMidfield: { x: 1050, y: 725 },
                offenseRightForward: { x: 1050, y: -950 },
                offenseLeftForward: { x: 1050, y: 225 },
                offenseGoalKeeper: { x: 1050, y: -750 },
                defenseGoalKeeper: { x: -1075, y: -750 },
                ball: { x: 0, y: 0 },
                sidelineRef: {x: 0, y: -1200}
            },
            nextStates: [
                { state: "start" }
            ],
            advanceOnCompletion: true
        },
        start: {
            moves: {
                defenseLeftBack: [{ coordinates: [{ x: -700, y: -750 }] }],
                defenseLeftCenterBack: [{ coordinates: [{ x: -650, y: -350 }] }],
                defenseRightCenterBack: [{ coordinates: [{ x: -650, y: 150 }] }],
                defenseRightBack: [{ coordinates: [{ x: -600, y: 550 }] }],
                defenseLeftMidfield: [{ coordinates: [{ x: -275, y: -900 }] }],
                defenseLeftCenterMidfield: [{ coordinates: [{ x: -375, y: -550 }] }],
                defenseRightCenterMidfield: [{ coordinates: [{ x: -400, y: 0 }] }],
                defenseRightMidfield: [{ coordinates: [{ x: -300, y: 250 }] }],
                defenseLeftForward: [{ coordinates: [{ x: -150, y: -600 }] }],
                defenseRightForward: [{ coordinates: [{ x: -150, y: 550 }] }],
                offenseRightBack: [{ coordinates: [{ x: 500, y: -900 }] }],
                offenseRightCenterBack: [{ coordinates: [{ x: 600, y: -350 }] }],
                offenseLeftCenterBack: [{ coordinates: [{ x: 600, y: 150 }] }],
                offenseLeftBack: [{ coordinates: [{ x: 500, y: 550 }] }],
                offenseRightMidfield: [{ coordinates: [{ x: 200, y: -800 }] }],
                offenseRightCenterMidfield: [{ coordinates: [{ x: 250, y: -400 }] }],
                offenseLeftCenterMidfield: [{ coordinates: [{ x: 300, y: 100 }] }],
                offenseLeftMidfield: [{ coordinates: [{ x: 150, y: 550 }] }],
                offenseRightForward: [{ coordinates: [{ x: 50, y: -200 }] }],
                offenseLeftForward: [{ coordinates: [{ x: 75, y: 80 }] }],
                offenseGoalKeeper: [{ coordinates: [{x:950, y:-700},{ x: 950, y: -125 }] }],
                defenseGoalKeeper: [{ coordinates: [{ x: -950, y: -700 }, { x: -950, y: -125 }] }]
            },
            nextStates: [
                { state: "question1" }
            ],
            soundFX: "cheer"
        },
        question1: {
            moves: {
                defenseLeftBack: [{ coordinates: [{ x: -600, y: -725 }] }],
                defenseLeftCenterBack: [{ coordinates: [{ x: -600, y: -325 }] }],
                defenseRightCenterBack: [{ coordinates: [{ x: -550, y: 200 }] }],
                defenseRightBack: [{ coordinates: [{ x: -500, y: 550 }] }],
                defenseLeftMidfield: [{ coordinates: [{ x: -50, y: -800 }] }],
                defenseLeftCenterMidfield: [{ coordinates: [{ x: -200, y: -475 }] }],
                defenseRightCenterMidfield: [{ coordinates: [{ x: 50, y: 150 }] }],
                defenseRightMidfield: [{ coordinates: [{ x: 0, y: 500 }] }],
                defenseLeftForward: [{ coordinates: [{ x: 450, y: -200 }] }],
                defenseRightForward: [{ coordinates: [{ x: 50, y: 400 }, { x: 350, y: 475 }] }],
                offenseRightBack: [{ coordinates: [{ x: 675, y: -800 }] }],
                offenseRightCenterBack: [{ coordinates: [{ x: 675, y: -275 }] }],
                offenseLeftCenterBack: [{ coordinates: [{ x: 650, y: 275 }] }],
                offenseLeftBack: [{ coordinates: [{ x: 625, y: 675 }] }],
                offenseRightMidfield: [{ coordinates: [{ x: 250, y: -850 }] }],
                offenseRightCenterMidfield: [{ coordinates: [{ x: 100, y: -350 }] }],
                offenseLeftCenterMidfield: [{ coordinates: [{ x: 275, y: 200 }] }],
                offenseLeftMidfield: [{ coordinates: [{ x: 250, y: 700 }] }],
                offenseRightForward: [{ coordinates: [{ x: -50, y: -300 }, { x: -350, y: -200 }] }],
                offenseLeftForward: [{ coordinates: [{ x: 100, y: 100 }], speed: 0.5 }, { coordinates: [{ x: -200, y: 275 }], speed: 1.5 }],
                ball: [{ coordinates: [{ x: 25, y: 200 }], speed: 0.5 }, { coordinates: [{ x: 125, y: 100 }, { x: 275, y: 200 }, { x: 425, y: 400 }, { x: 575, y: 750 }], speed: 1.5 }],
                offenseGoalKeeper: [{ coordinates: [{ x: 950, y: 0 }] }],
                defenseGoalKeeper: [{ coordinates: [{ x: -950, y: -100 }] }],
                sidelineRef: [{ coordinates: [{ x: 250, y: -1200 }] }]
            },
            nextStates: [
                { state: "question2A", trigger: "offenseLeftMidfield" },
                { state: "question2B", trigger: "offenseRightBack" }
            ],
            errorState: "yellow1",
            playerWithBall: "offenseLeftBack",
            soundFX: "ole"
        },
        question2A: {
            moves: {
                defenseLeftBack: [{ coordinates: [{ x: -550, y: -750 }], speed: 1 }],
                defenseLeftCenterBack: [{ coordinates: [{ x: -550, y: -225 }], speed: 1 }],
                defenseRightCenterBack: [{ coordinates: [{ x: -500, y: 300 }], speed: 1 }],
                defenseRightBack: [{ coordinates: [{ x: -425, y: 600 }], speed: 1 }],
                defenseLeftMidfield: [{ coordinates: [{ x: 100, y: -800 }], speed: 1 }],
                defenseLeftCenterMidfield: [{ coordinates: [{ x: -100, y: -450 }], speed: 1 }],
                defenseRightCenterMidfield: [{ coordinates: [{ x: -25, y: 75 }], speed: 1 }],
                defenseRightMidfield: [{ coordinates: [{ x: 150, y: 700 }], speed: 1 }],
                defenseLeftForward: [{ coordinates: [{ x: 350, y: -125 }], speed: 1 }],
                defenseRightForward: [{ coordinates: [{ x: 350, y: 600 }], speed: 1 }],
                offenseRightBack: [{ coordinates: [{ x: 525, y: -800 }], speed: 1 }],
                offenseRightCenterBack: [{ coordinates: [{ x: 650, y: -300 }], speed: 1 }],
                offenseLeftCenterBack: [{ coordinates: [{ x: 700, y: 300 }], speed: 1 }],
                offenseLeftBack: [{ coordinates: [{ x: 675, y: 750 }], speed: 1 }],
                offenseRightMidfield: [{ coordinates: [{ x: -150, y: -750 }], speed: 1 }],
                offenseRightCenterMidfield: [{ coordinates: [{ x: 75, y: -350 }], speed: 1 }],
                offenseLeftCenterMidfield: [{ coordinates: [{ x: 100, y: 250 }], speed: 1 }],
                offenseLeftMidfield: [{ coordinates: [{ x: 275, y: 800 }], speed: 1 }],
                offenseRightForward: [{ coordinates: [{ x: -325, y: -200 }], speed: 1 }],
                offenseLeftForward: [{ coordinates: [{ x: -200, y: 600 }], speed: 1 }],
                ball: [{ coordinates: [{ x: 500, y: 700 }, { x: 375, y: 750 }, { x: 275, y: 825 }, { x: 225, y: 875 }], speed: 1 }],
                offenseGoalKeeper: [{ coordinates: [{ x: 950, y: 0 }], speed: 1 }],
                defenseGoalKeeper: [{ coordinates: [{ x: -950, y: -25 }], speed: 1 }],
                sidelineRef: [{ coordinates: [{ x: 200, y: -1200 }], speed: 1 }]
            },
            nextStates: [
                { state: "question3A", trigger: "offenseLeftForward" },
                { state: "question3B", trigger: "offenseLeftCenterMidfield" }
            ],
            errorState: "yellow2A",
            playerWithBall: "offenseLeftMidfield"
        },
        question2B: {
            moves: {
                defenseLeftBack: [{ coordinates: [{ x: -400, y: -850 }], speed: 1.5 }],
                defenseLeftCenterBack: [{ coordinates: [{ x: -500, y: -425 }], speed: 1.5 }],
                defenseRightCenterBack: [{ coordinates: [{ x: -450, y: 250 }], speed: 1.5 }],
                defenseRightBack: [{ coordinates: [{ x: -350, y: 500 }], speed: 1.5 }],
                defenseLeftMidfield: [{ coordinates: [{ x: 300, y: -800 }], speed: 1.5 }],
                defenseLeftCenterMidfield: [{ coordinates: [{ x: -50, y: -500 }], speed: 1.5 }],
                defenseRightCenterMidfield: [{ coordinates: [{ x: 0, y: 50 }], speed: 1.5 }],
                defenseRightMidfield: [{ coordinates: [{ x: 150, y: 550 }], speed: 1.5 }],
                defenseLeftForward: [{ coordinates: [{ x: 550, y: -400 }], speed: 1.5 }],
                defenseRightForward: [{ coordinates: [{ x: 400, y: 300 }], speed: 1.5 }],
                offenseRightBack: [{ coordinates: [{ x: 575, y: -900 }], speed: 1.5 }],
                offenseRightCenterBack: [{ coordinates: [{ x: 725, y: -375 }], speed: 1.5 }],
                offenseLeftCenterBack: [{ coordinates: [{ x: 700, y: 150 }], speed: 1.5 }],
                offenseLeftBack: [{ coordinates: [{ x: 675, y: 575 }], speed: 1.5 }],
                offenseRightMidfield: [{ coordinates: [{ x: 50, y: -950 }], speed: 1.5 }],
                offenseRightCenterMidfield: [{ coordinates: [{ x: 300, y: -350 }], speed: 1.5 }],
                offenseLeftCenterMidfield: [{ coordinates: [{ x: 150, y: 200 }], speed: 1.5 }],
                offenseLeftMidfield: [{ coordinates: [{ x: 50, y: 750 }], speed: 1.5 }],
                offenseRightForward: [{ coordinates: [{ x: -250, y: -400 }], speed: 1.5 }],
                offenseLeftForward: [{ coordinates: [{ x: -200, y: 200 }], speed: 1.5 }],
                ball: [{ coordinates: [{ x: 650, y: 400 }, { x: 700, y: 100 }, { x: 700, y: -200 }, { x: 600, y: -600 }, { x: 500, y: -825 }], speed: 1.5 }],
                offenseGoalKeeper: [{ coordinates: [{ x: 950, y: -250 }], speed: 1.5 }],
                defenseGoalKeeper: [{ coordinates: [{ x: -950, y: -200 }], speed: 1.5 }],
                sidelineRef: [{ coordinates: [{ x: 350, y: -1200 }], speed: 1.5 }]
            },
            nextStates: [
                { state: "question3C", trigger: "offenseRightCenterMidfield" },
                { state: "question3D", trigger: "offenseRightMidfield" }
            ],
            errorState: "yellow2B",
            playerWithBall: "offenseRightBack"
        },
        question3A: {
            moves: {
                defenseLeftBack: [{ coordinates: [{ x: -500, y: -750 }], speed: 1.5 }],
                defenseLeftCenterBack: [{ coordinates: [{ x: -550, y: -300 }], speed: 1.5 }],
                defenseRightCenterBack: [{ coordinates: [{ x: -500, y: 200 }], speed: 1.5 }],
                defenseRightBack: [{ coordinates: [{ x: -400, y: 675 }], speed: 1.5 }],
                defenseLeftMidfield: [{ coordinates: [{ x: 0, y: -800 }], speed: 1.5 }],
                defenseLeftCenterMidfield: [{ coordinates: [{ x: -75, y: -400 }], speed: 1.5 }],
                defenseRightCenterMidfield: [{ coordinates: [{ x: -100, y: 275 }], speed: 1.5 }],
                defenseRightMidfield: [{ coordinates: [{ x: 0, y: 700 }], speed: 1.5 }],
                defenseLeftForward: [{ coordinates: [{ x: 300, y: -125 }], speed: 1.5 }],
                defenseRightForward: [{ coordinates: [{ x: 300, y: 600 }], speed: 1.5 }],
                offenseRightBack: [{ coordinates: [{ x: 325, y: -800 }], speed: 1.5 }],
                offenseRightCenterBack: [{ coordinates: [{ x: 450, y: -300 }], speed: 1.5 }],
                offenseLeftCenterBack: [{ coordinates: [{ x: 500, y: 300 }], speed: 1.5 }],
                offenseLeftBack: [{ coordinates: [{ x: 525, y: 750 }], speed: 1.5 }],
                offenseRightMidfield: [{ coordinates: [{ x: -250, y: -800 }], speed: 1.5 }],
                offenseRightCenterMidfield: [{ coordinates: [{ x: -50, y: -75 }, { x: -400, y: -50 }], speed: 1.5 }],
                offenseLeftCenterMidfield: [{ coordinates: [{ x: -450, y: 450 }], speed: 1.5 }],
                offenseLeftMidfield: [{ coordinates: [{ x: 200, y: 600 }, { x: 0, y: 400 }], speed: 1.5 }],
                offenseRightForward: [{ coordinates: [{ x: -400, y: -400 }], speed: 1.5 }],
                offenseLeftForward: [{ coordinates: [{ x: -300, y: 800 }], speed: 1.5 }],
                ball: [{ coordinates: [{ x: -350, y: 875 }], speed: 1.5 }],
                offenseGoalKeeper: [{ coordinates: [{ x: 950, y: -50 }], speed: 1.5 }],
                defenseGoalKeeper: [{ coordinates: [{ x: -950, y: 50 }], speed: 1.5 }],
                sidelineRef: [{ coordinates: [{ x: -250, y: -1200 }], speed: 1.5 }]
            },
            nextStates: [
                { state: "question4A", trigger: "offenseLeftCenterMidfield" },
                { state: "question4B", trigger: "offenseRightCenterMidfield" }
            ],
            errorState: "yellow3A",
            playerWithBall: "offenseLeftForward"
        },
        question3B: {
            moves: {
                defenseLeftBack: [{ coordinates: [{ x: -625, y: -700 }], speed: 1.5 }],
                defenseLeftCenterBack: [{ coordinates: [{ x: -650, y: -275 }], speed: 1.5 }],
                defenseRightCenterBack: [{ coordinates: [{ x: -550, y: 400 }, { x: -600, y: 300 }], speed: 1.5 }],
                defenseRightBack: [{ coordinates: [{ x: -400, y: 500 }, { x: -450, y: 600 }], speed: 1.5 }],
                defenseLeftMidfield: [{ coordinates: [{ x: -100, y: -800 }], speed: 1.5 }],
                defenseLeftCenterMidfield: [{ coordinates: [{ x: -300, y: -450 }], speed: 1.5 }],
                defenseRightCenterMidfield: [{ coordinates: [{ x: -150, y: 100 }], speed: 1.5 }],
                defenseRightMidfield: [{ coordinates: [{ x: -50, y: 750 }, { x: -150, y: 600 }], speed: 1.5 }],
                defenseLeftForward: [{ coordinates: [{ x: 150, y: -125 }], speed: 1.5 }],
                defenseRightForward: [{ coordinates: [{ x: 150, y: 600 }], speed: 1.5 }],
                offenseRightBack: [{ coordinates: [{ x: 275, y: -800 }], speed: 1.5 }],
                offenseRightCenterBack: [{ coordinates: [{ x: 400, y: -300 }], speed: 1.5 }],
                offenseLeftCenterBack: [{ coordinates: [{ x: 400, y: 300 }], speed: 1.5 }],
                offenseLeftBack: [{ coordinates: [{ x: 425, y: 750 }], speed: 1.5 }],
                offenseRightMidfield: [{ coordinates: [{ x: -450, y: -700 }], speed: 1.5 }],
                offenseRightCenterMidfield: [{ coordinates: [{ x: -175, y: -600 }], speed: 1.5 }],
                offenseLeftCenterMidfield: [{ coordinates: [{ x: -175, y: 300 }], speed: 1.5 }],
                offenseLeftMidfield: [{ coordinates: [{ x: -300, y: 700 }], speed: 1.5 }],
                offenseRightForward: [{ coordinates: [{ x: -475, y: -250 }], speed: 1.5 }],
                offenseLeftForward: [{ coordinates: [{ x: -450, y: 250 }], speed: 1.5 }],
                ball: [{ coordinates: [{ x: 75, y: 600 }, { x: -25, y: 450 }, { x: -125, y: 400 }, { x: -225, y: 375 }], speed: 1.5 }],
                offenseGoalKeeper: [{ coordinates: [{ x: 950, y: -25 }], speed: 1.5 }],
                defenseGoalKeeper: [{ coordinates: [{ x: -950, y: -25 }], speed: 1.5 }],
                sidelineRef: [{ coordinates: [{ x: -150, y: -1200 }], speed: 1.5 }]
            },
            nextStates: [
                { state: "question4C", trigger: "offenseLeftForward" },
                { state: "question4D", trigger: "offenseRightForward" }
            ],
            errorState: "yellow3B",
            playerWithBall: "offenseLeftCenterMidfield"
        },
        question3C: {
            moves: {
                defenseLeftBack: [{ coordinates: [{ x: -450, y: -850 }], speed: 1.5 }],
                defenseLeftCenterBack: [{ coordinates: [{ x: -525, y: -350 }], speed: 1.5 }],
                defenseRightCenterBack: [{ coordinates: [{ x: -500, y: 150 }], speed: 1.5 }],
                defenseRightBack: [{ coordinates: [{ x: -400, y: 600 }], speed: 1.5 }],
                defenseLeftMidfield: [{ coordinates: [{ x: 0, y: -800 }], speed: 1.5 }],
                defenseLeftCenterMidfield: [{ coordinates: [{ x: -100, y: -300 }], speed: 1.5 }],
                defenseRightCenterMidfield: [{ coordinates: [{ x: -250, y: 275 }], speed: 1.5 }],
                defenseRightMidfield: [{ coordinates: [{ x: -50, y: 550 }], speed: 1.5 }],
                defenseLeftForward: [{ coordinates: [{ x: 350, y: -400 }], speed: 1.5 }],
                defenseRightForward: [{ coordinates: [{ x: 200, y: 300 }], speed: 1.5 }],
                offenseRightBack: [{ coordinates: [{ x: 375, y: -900 }], speed: 1.5 }],
                offenseRightCenterBack: [{ coordinates: [{ x: 525, y: -375 }], speed: 1.5 }],
                offenseLeftCenterBack: [{ coordinates: [{ x: 500, y: 150 }], speed: 1.5 }],
                offenseLeftBack: [{ coordinates: [{ x: 475, y: 575 }], speed: 1.5 }],
                offenseRightMidfield: [{ coordinates: [{ x: -350, y: -950 }], speed: 1.5 }],
                offenseRightCenterMidfield: [{ coordinates: [{ x: 0, y: -150 }], speed: 1.5 }],
                offenseLeftCenterMidfield: [{ coordinates: [{ x: -150, y: 350 }], speed: 1.5 }],
                offenseLeftMidfield: [{ coordinates: [{ x: -250, y: 750 }], speed: 1.5 }],
                offenseRightForward: [{ coordinates: [{ x: -350, y: -300 }], speed: 1.5 }],
                offenseLeftForward: [{ coordinates: [{ x: -400, y: 300 }], speed: 1.5 }],
                ball: [{ coordinates: [{ x: -50, y: -50 }], speed: 1.5 }],
                offenseGoalKeeper: [{ coordinates: [{ x: 950, y: -75 }], speed: 1.5 }],
                defenseGoalKeeper: [{ coordinates: [{ x: -950, y: -150 }], speed: 1.5 }],
                sidelineRef: [{ coordinates: [{ x: 0, y: -1200 }], speed: 1.5 }]
            },
            nextStates: [
                { state: "question4E", trigger: "offenseLeftForward" },
                { state: "question4F", trigger: "offenseRightForward" }
            ],
            errorState: "yellow3C",
            playerWithBall: "offenseRightCenterMidfield"
        },
        question3D: {
            moves: {
                defenseLeftBack: [{ coordinates: [{ x: -300, y: -900 }], speed: 1.5 }],
                defenseLeftCenterBack: [{ coordinates: [{ x: -575, y: -625 }], speed: 1.5 }],
                defenseRightCenterBack: [{ coordinates: [{ x: -500, y: -50 }], speed: 1.5 }],
                defenseRightBack: [{ coordinates: [{ x: -450, y: 500 }], speed: 1.5 }],
                defenseLeftMidfield: [{ coordinates: [{ x: 100, y: -800 }], speed: 1.5 }],
                defenseLeftCenterMidfield: [{ coordinates: [{ x: -100, y: -500 }], speed: 1.5 }],
                defenseRightCenterMidfield: [{ coordinates: [{ x: -225, y: -50 }], speed: 1.5 }],
                defenseRightMidfield: [{ coordinates: [{ x: 0, y: 550 }], speed: 1.5 }],
                defenseLeftForward: [{ coordinates: [{ x: 350, y: -400 }], speed: 1.5 }],
                defenseRightForward: [{ coordinates: [{ x: 200, y: 300 }], speed: 1.5 }],
                offenseRightBack: [{ coordinates: [{ x: 475, y: -900 }], speed: 1.5 }],
                offenseRightCenterBack: [{ coordinates: [{ x: 525, y: -375 }], speed: 1.5 }],
                offenseLeftCenterBack: [{ coordinates: [{ x: 500, y: 150 }], speed: 1.5 }],
                offenseLeftBack: [{ coordinates: [{ x: 475, y: 575 }], speed: 1.5 }],
                offenseRightMidfield: [{ coordinates: [{ x: -150, y: -1050 }], speed: 1.5 }],
                offenseRightCenterMidfield: [{ coordinates: [{ x: 150, y: -350 }], speed: 1.5 }],
                offenseLeftCenterMidfield: [{ coordinates: [{ x: -150, y: 300 }], speed: 1.5 }],
                offenseLeftMidfield: [{ coordinates: [{ x: -250, y: 750 }], speed: 1.5 }],
                offenseRightForward: [{ coordinates: [{ x: -475, y: -800 }], speed: 1.5 }],
                offenseLeftForward: [{ coordinates: [{ x: -375, y: -250 }], speed: 1.5 }],
                ball: [{ coordinates: [{ x: -210, y: -950 }], speed: 1.5 }],
                offenseGoalKeeper: [{ coordinates: [{ x: 950, y: -175 }], speed: 1.5 }],
                defenseGoalKeeper: [{ coordinates: [{ x: -950, y: -200 }], speed: 1.5 }],
                sidelineRef: [{ coordinates: [{ x: -150, y: -1200 }], speed: 1.5 }]
            },
            nextStates: [
                { state: "question4G", trigger: "offenseLeftForward" },
                { state: "question4H", trigger: "offenseRightForward" }
            ],
            errorState: "yellow3D",
            playerWithBall: "offenseRightMidfield"
        },
        question4A: {
            moves: {
                defenseLeftBack: [{ coordinates: [{ x: -825, y: -600 }], speed: 1.5 }],
                defenseLeftCenterBack: [{ coordinates: [{ x: -800, y: 0 }], speed: 1.5 }],
                defenseRightCenterBack: [{ coordinates: [{ x: -750, y: 425 }], speed: 1.5 }],
                defenseRightBack: [{ coordinates: [{ x: -825, y: 675 }], speed: 1.5 }],
                defenseLeftMidfield: [{ coordinates: [{ x: -400, y: -700 }], speed: 1.5 }],
                defenseLeftCenterMidfield: [{ coordinates: [{ x: -375, y: -300 }], speed: 1.5 }],
                defenseRightCenterMidfield: [{ coordinates: [{ x: -400, y: 175 }], speed: 1.5 }],
                defenseRightMidfield: [{ coordinates: [{ x: -350, y: 600 }], speed: 1.5 }],
                defenseLeftForward: [{ coordinates: [{ x: 100, y: -125 }], speed: 1.5 }],
                defenseRightForward: [{ coordinates: [{ x: 100, y: 600 }], speed: 1.5 }],
                offenseRightBack: [{ coordinates: [{ x: 125, y: -800 }], speed: 1.5 }],
                offenseRightCenterBack: [{ coordinates: [{ x: 250, y: -300 }], speed: 1.5 }],
                offenseLeftCenterBack: [{ coordinates: [{ x: 300, y: 300 }], speed: 1.5 }],
                offenseLeftBack: [{ coordinates: [{ x: 325, y: 750 }], speed: 1.5 }],
                offenseRightMidfield: [{ coordinates: [{ x: -600, y: -750 }], speed: 1.5 }],
                offenseRightCenterMidfield: [{ coordinates: [{ x: -650, y: 75 }], speed: 1.5 }],
                offenseLeftCenterMidfield: [{ coordinates: [{ x: -900, y: 750 }], speed: 1.5 }],
                offenseLeftMidfield: [{ coordinates: [{ x: -250, y: 300 }], speed: 1.5 }],
                offenseRightForward: [{ coordinates: [{ x: -600, y: -350 }], speed: 1.5 }],
                offenseLeftForward: [{ coordinates: [{ x: -625, y: 500 }], speed: 1.5 }],
                ball: [{ coordinates: [{ x: -935, y: 825 }], speed: 1.5 }],
                offenseGoalKeeper: [{ coordinates: [{ x: 950, y: 25 }], speed: 1.5 }],
                defenseGoalKeeper: [{ coordinates: [{ x: -950, y: 50 }], speed: 1.5 }],
                sidelineRef: [{ coordinates: [{ x: -550, y: -1200 }], speed: 1.5 }]
            },
            nextStates: [
                { state: "goal4A", trigger: "offenseLeftCenterMidfield" }
            ],
            errorState: "yellow4A",
            playerWithBall: "offenseLeftCenterMidfield"
        },
        question4B: {
            moves: {
                defenseLeftBack: [{ coordinates: [{ x: -650, y: -650 }], speed: 1.5 }],
                defenseLeftCenterBack: [{ coordinates: [{ x: -750, y: -200 }], speed: 1.5 }],
                defenseRightCenterBack: [{ coordinates: [{ x: -650, y: 250 }], speed: 1.5 }],
                defenseRightBack: [{ coordinates: [{ x: -550, y: 600 }], speed: 1.5 }],
                defenseLeftMidfield: [{ coordinates: [{ x: -300, y: -600 }], speed: 1.5 }],
                defenseLeftCenterMidfield: [{ coordinates: [{ x: -375, y: -200 }], speed: 1.5 }],
                defenseRightCenterMidfield: [{ coordinates: [{ x: -400, y: 175 }], speed: 1.5 }],
                defenseRightMidfield: [{ coordinates: [{ x: -450, y: 600 }], speed: 1.5 }],
                defenseLeftForward: [{ coordinates: [{ x: 100, y: -25 }], speed: 1.5 }],
                defenseRightForward: [{ coordinates: [{ x: 100, y: 400 }], speed: 1.5 }],
                offenseRightBack: [{ coordinates: [{ x: 125, y: -800 }], speed: 1.5 }],
                offenseRightCenterBack: [{ coordinates: [{ x: 250, y: -300 }], speed: 1.5 }],
                offenseLeftCenterBack: [{ coordinates: [{ x: 300, y: 300 }], speed: 1.5 }],
                offenseLeftBack: [{ coordinates: [{ x: 325, y: 750 }], speed: 1.5 }],
                offenseRightMidfield: [{ coordinates: [{ x: -450, y: -800 }], speed: 1.5 }],
                offenseRightCenterMidfield: [{ coordinates: [{ x: -700, y: 0 }], speed: 1.5 }],
                offenseLeftCenterMidfield: [{ coordinates: [{ x: -650, y: 350 }], speed: 1.5 }],
                offenseLeftMidfield: [{ coordinates: [{ x: -200, y: 400 }], speed: 1.5 }],
                offenseRightForward: [{ coordinates: [{ x: -650, y: -400 }], speed: 1.5 }],
                offenseLeftForward: [{ coordinates: [{ x: -550, y: 800 }], speed: 1.5 }],
                ball: [{ coordinates: [{ x: -650, y: 475 }, { x: -750, y: 75 }], speed: 1.5 }],
                offenseGoalKeeper: [{ coordinates: [{ x: 950, y: -150 }], speed: 1.5 }],
                defenseGoalKeeper: [{ coordinates: [{ x: -950, y: -50 }], speed: 1.5 }],
                sidelineRef: [{ coordinates: [{ x: -450, y: -1200 }], speed: 1.5 }]
            },
            nextStates: [
                { state: "goal4B", trigger: "offenseRightCenterMidfield" }
            ],
            errorState: "yellow4B",
            playerWithBall: "offenseRightCenterMidfield"
        },
        question4C: {
            moves: {
                defenseLeftBack: [{ coordinates: [{ x: -725, y: -700 }], speed: 1 }],
                defenseLeftCenterBack: [{ coordinates: [{ x: -675, y: -350 }], speed: 1 }],
                defenseRightCenterBack: [{ coordinates: [{ x: -675, y: 50 }], speed: 1 }],
                defenseRightBack: [{ coordinates: [{ x: -650, y: 500 }], speed: 1 }],
                defenseLeftMidfield: [{ coordinates: [{ x: -500, y: -800 }], speed: 1 }],
                defenseLeftCenterMidfield: [{ coordinates: [{ x: -475, y: -200 }], speed: 1 }],
                defenseRightCenterMidfield: [{ coordinates: [{ x: -450, y: 50 }], speed: 1 }],
                defenseRightMidfield: [{ coordinates: [{ x: -450, y: 600 }], speed: 1 }],
                defenseLeftForward: [{ coordinates: [{ x: -150, y: -25 }], speed: 1 }],
                defenseRightForward: [{ coordinates: [{ x: -150, y: 400 }], speed: 1 }],
                offenseRightBack: [{ coordinates: [{ x: 75, y: -800 }], speed: 1 }],
                offenseRightCenterBack: [{ coordinates: [{ x: 200, y: -300 }], speed: 1 }],
                offenseLeftCenterBack: [{ coordinates: [{ x: 200, y: 300 }], speed: 1 }],
                offenseLeftBack: [{ coordinates: [{ x: 225, y: 750 }], speed: 1 }],
                offenseRightMidfield: [{ coordinates: [{ x: -550, y: -650 }], speed: 1 }],
                offenseRightCenterMidfield: [{ coordinates: [{ x: -400, y: -600 }], speed: 1 }],
                offenseLeftCenterMidfield: [{ coordinates: [{ x: -475, y: 300 }], speed: 1 }],
                offenseLeftMidfield: [{ coordinates: [{ x: -550, y: 600 }], speed: 1 }],
                offenseRightForward: [{ coordinates: [{ x: -575, y: -375 }], speed: 1 }],
                offenseLeftForward: [{ coordinates: [{ x: -675, y: -150 }], speed: 1 }],
                ball: [{ coordinates: [{ x: -725, y: -25 }], speed: 1 }],
                offenseGoalKeeper: [{ coordinates: [{ x: 950, y: -100 }], speed: 1 }],
                defenseGoalKeeper: [{ coordinates: [{ x: -950, y: -150 }], speed: 1 }],
                sidelineRef: [{ coordinates: [{ x: -550, y: -1200 }], speed: 1 }]
            },
            nextStates: [
                { state: "goal4C", trigger: "offenseLeftForward" }
            ],
            errorState: "yellow4C",
            playerWithBall: "offenseLeftForward"
        },
        question4D: {
            moves: {
                defenseLeftBack: [{ coordinates: [{ x: -800, y: -500 }], speed: 1.25 }],
                defenseLeftCenterBack: [{ coordinates: [{ x: -800, y: -75 }], speed: 1.25 }],
                defenseRightCenterBack: [{ coordinates: [{ x: -700, y: 300 }, { x: -725, y: 250 }], speed: 1.25 }],
                defenseRightBack: [{ coordinates: [{ x: -750, y: 550 }], speed: 1.25 }],
                defenseLeftMidfield: [{ coordinates: [{ x: -300, y: -700 }], speed: 1.25 }],
                defenseLeftCenterMidfield: [{ coordinates: [{ x: -500, y: -300 }], speed: 1.25 }],
                defenseRightCenterMidfield: [{ coordinates: [{ x: -450, y: 100 }], speed: 1.25 }],
                defenseRightMidfield: [{ coordinates: [{ x: -350, y: 500 }], speed: 1.25 }],
                defenseLeftForward: [{ coordinates: [{ x: -150, y: -25 }], speed: 1.25 }],
                defenseRightForward: [{ coordinates: [{ x: -150, y: 400 }], speed: 1.25 }],
                offenseRightBack: [{ coordinates: [{ x: 75, y: -800 }], speed: 1.25 }],
                offenseRightCenterBack: [{ coordinates: [{ x: 200, y: -300 }], speed: 1.25 }],
                offenseLeftCenterBack: [{ coordinates: [{ x: 200, y: 300 }], speed: 1.25 }],
                offenseLeftBack: [{ coordinates: [{ x: 225, y: 750 }], speed: 1.25 }],
                offenseRightMidfield: [{ coordinates: [{ x: -650, y: -600 }], speed: 1.25 }],
                offenseRightCenterMidfield: [{ coordinates: [{ x: -375, y: -500 }], speed: 1.25 }],
                offenseLeftCenterMidfield: [{ coordinates: [{ x: -375, y: 300 }], speed: 1.25 }],
                offenseLeftMidfield: [{ coordinates: [{ x: -600, y: 600 }], speed: 1.25 }],
                offenseRightForward: [{ coordinates: [{ x: -675, y: 50 }], speed: 1.25 }],
                offenseLeftForward: [{ coordinates: [{ x: -550, y: 350 }], speed: 1.25 }],
                ball: [{ coordinates: [{ x: -725, y: 125 }], speed: 1.25 }],
                offenseGoalKeeper: [{ coordinates: [{ x: 950, y: -75 }], speed: 1.25 }],
                defenseGoalKeeper: [{ coordinates: [{ x: -950, y: -50 }], speed: 1.25 }],
                sidelineRef: [{ coordinates: [{ x: -450, y: -1200 }], speed: 1.25 }]
            },
            nextStates: [
                { state: "goal4D", trigger: "offenseRightForward" }
            ],
            errorState: "yellow4D",
            playerWithBall: "offenseRightForward"
        },
        question4E: {
            moves: {
                defenseLeftBack: [{ coordinates: [{ x: -700, y: -650 }], speed: 1.5 }],
                defenseLeftCenterBack: [{ coordinates: [{ x: -725, y: -200 }], speed: 1.5 }],
                defenseRightCenterBack: [{ coordinates: [{ x: -700, y: 300 }], speed: 1.5 }],
                defenseRightBack: [{ coordinates: [{ x: -600, y: 500 }], speed: 1.5 }],
                defenseLeftMidfield: [{ coordinates: [{ x: -450, y: -600 }], speed: 1.5 }],
                defenseLeftCenterMidfield: [{ coordinates: [{ x: -350, y: -200 }], speed: 1.5 }],
                defenseRightCenterMidfield: [{ coordinates: [{ x: -450, y: 200 }], speed: 1.5 }],
                defenseRightMidfield: [{ coordinates: [{ x: -350, y: 650 }], speed: 1.5 }],
                defenseLeftForward: [{ coordinates: [{ x: -150, y: -100 }], speed: 1.5 }],
                defenseRightForward: [{ coordinates: [{ x: -200, y: 400 }], speed: 1.5 }],
                offenseRightBack: [{ coordinates: [{ x: 75, y: -800 }], speed: 1.5 }],
                offenseRightCenterBack: [{ coordinates: [{ x: 25, y: -275 }], speed: 1.5 }],
                offenseLeftCenterBack: [{ coordinates: [{ x: 100, y: 200 }], speed: 1.5 }],
                offenseLeftBack: [{ coordinates: [{ x: 75, y: 500 }], speed: 1.5 }],
                offenseRightMidfield: [{ coordinates: [{ x: -800, y: -800 }], speed: 1.5 }],
                offenseRightCenterMidfield: [{ coordinates: [{ x: -300, y: -50 }, { x: -500, y: -150 }], speed: 1.5 }],
                offenseLeftCenterMidfield: [{ coordinates: [{ x: -350, y: 450 }, { x: -400, y: 400 }], speed: 1.5 }],
                offenseLeftMidfield: [{ coordinates: [{ x: -450, y: 800 }], speed: 1.5 }],
                offenseRightForward: [{ coordinates: [{ x: -650, y: 100 }], speed: 1.5 }],
                offenseLeftForward: [{ coordinates: [{ x: -750, y: 450 }], speed: 1.5 }],
                ball: [{ coordinates: [{ x: -800, y: 525 }], speed: 1.5 }],
                offenseGoalKeeper: [{ coordinates: [{ x: 950, y: 25 }], speed: 1.5 }],
                defenseGoalKeeper: [{ coordinates: [{ x: -950, y: 100 }], speed: 1.5 }],
                sidelineRef: [{ coordinates: [{ x: -600, y: -1200 }], speed: 1.5 }]
            },
            nextStates: [
                { state: "goal4E", trigger: "offenseLeftForward" }
            ],
            errorState: "yellow4E",
            playerWithBall: "offenseLeftForward"
        },
        question4F: {
            moves: {
                defenseLeftBack: [{ coordinates: [{ x: -750, y: -650 }], speed: 1 }],
                defenseLeftCenterBack: [{ coordinates: [{ x: -700, y: -250 }], speed: 1 }],
                defenseRightCenterBack: [{ coordinates: [{ x: -700, y: 150 }], speed: 1 }],
                defenseRightBack: [{ coordinates: [{ x: -650, y: 500 }], speed: 1 }],
                defenseLeftMidfield: [{ coordinates: [{ x: -450, y: -600 }], speed: 1 }],
                defenseLeftCenterMidfield: [{ coordinates: [{ x: -350, y: -200 }], speed: 1 }],
                defenseRightCenterMidfield: [{ coordinates: [{ x: -450, y: 100 }], speed: 1 }],
                defenseRightMidfield: [{ coordinates: [{ x: -350, y: 650 }], speed: 1 }],
                defenseLeftForward: [{ coordinates: [{ x: -50, y: -300 }], speed: 1 }],
                defenseRightForward: [{ coordinates: [{ x: 0, y: 400 }], speed: 1 }],
                offenseRightBack: [{ coordinates: [{ x: 75, y: -700 }], speed: 1 }],
                offenseRightCenterBack: [{ coordinates: [{ x: 25, y: -300 }], speed: 1 }],
                offenseLeftCenterBack: [{ coordinates: [{ x: 100, y: 100 }], speed: 1 }],
                offenseLeftBack: [{ coordinates: [{ x: 75, y: 375 }], speed: 1 }],
                offenseRightMidfield: [{ coordinates: [{ x: -650, y: -550 }], speed: 1 }],
                offenseRightCenterMidfield: [{ coordinates: [{ x: -350, y: -50 }], speed: 1 }],
                offenseLeftCenterMidfield: [{ coordinates: [{ x: -350, y: 300 }], speed: 1 }],
                offenseLeftMidfield: [{ coordinates: [{ x: -650, y: 650 }], speed: 1 }],
                offenseRightForward: [{ coordinates: [{ x: -725, y: -100 }], speed: 1 }],
                offenseLeftForward: [{ coordinates: [{ x: -600, y: 400 }], speed: 1 }],
                ball: [{ coordinates: [{ x: -775, y: -25 }], speed: 1 }],
                offenseGoalKeeper: [{ coordinates: [{ x: 950, y: 0 }], speed: 1 }],
                defenseGoalKeeper: [{ coordinates: [{ x: -950, y: -100 }], speed: 1 }],
                sidelineRef: [{ coordinates: [{ x: -650, y: -1200 }], speed: 1 }]
            },
            nextStates: [
                { state: "goal4F", trigger: "offenseRightForward" }
            ],
            errorState: "yellow4F",
            playerWithBall: "offenseRightForward"
        },
        question4G: {
            moves: {
                defenseLeftBack: [{ coordinates: [{ x: -650, y: -775 }], speed: 1.5 }],
                defenseLeftCenterBack: [{ coordinates: [{ x: -750, y: -550 }], speed: 1.5 }],
                defenseRightCenterBack: [{ coordinates: [{ x: -725, y: -150 }], speed: 1.5 }],
                defenseRightBack: [{ coordinates: [{ x: -650, y: 400 }], speed: 1.5 }],
                defenseLeftMidfield: [{ coordinates: [{ x: -300, y: -750 }], speed: 1.5 }],
                defenseLeftCenterMidfield: [{ coordinates: [{ x: -350, y: -450 }], speed: 1.5 }],
                defenseRightCenterMidfield: [{ coordinates: [{ x: -425, y: 0 }], speed: 1.5 }],
                defenseRightMidfield: [{ coordinates: [{ x: -350, y: 450 }], speed: 1.5 }],
                defenseLeftForward: [{ coordinates: [{ x: 50, y: -300 }], speed: 1.5 }],
                defenseRightForward: [{ coordinates: [{ x: 0, y: 200 }], speed: 1.5 }],
                offenseRightBack: [{ coordinates: [{ x: 275, y: -700 }], speed: 1.5 }],
                offenseRightCenterBack: [{ coordinates: [{ x: 325, y: -300 }], speed: 1.5 }],
                offenseLeftCenterBack: [{ coordinates: [{ x: 300, y: 100 }], speed: 1.5 }],
                offenseLeftBack: [{ coordinates: [{ x: 175, y: 400 }], speed: 1.5 }],
                offenseRightMidfield: [{ coordinates: [{x:-150,y:-755},{ x: -150, y: -750 }, {x:-160,y:-755}, { x: -450, y: -950 }], speed: 1.5 }],
                offenseRightCenterMidfield: [{ coordinates: [{ x: -250, y: -250 }], speed: 1.5 }],
                offenseLeftCenterMidfield: [{ coordinates: [{ x: -550, y: 150 }], speed: 1.5 }],
                offenseLeftMidfield: [{ coordinates: [{ x: -450, y: 650 }], speed: 1.5 }],
                offenseRightForward: [{ coordinates: [{ x: -650, y: -650 }], speed: 1.5 }],
                offenseLeftForward: [{ coordinates: [{ x: -575, y: -400 }], speed: 1.5 }],
                ball: [{ coordinates: [{x:-200,y:-675}, { x: -200, y: -650 },{x:-210, y:-650}, { x: -250, y: -650 }, { x: -625, y: -325 }], speed: 1.5 }],
                offenseGoalKeeper: [{ coordinates: [{ x: 950, y: -100 }], speed: 1.5 }],
                defenseGoalKeeper: [{ coordinates: [{ x: -950, y: -300 }], speed: 1.5 }],
                sidelineRef: [{ coordinates: [{ x: -500, y: -1200 }], speed: 1.5 }]
            },
            nextStates: [
                { state: "goal4G", trigger: "offenseLeftForward" }
            ],
            errorState: "yellow4G",
            playerWithBall: "offenseLeftForward"
        },
        question4H: {
            moves: {
                defenseLeftBack: [{ coordinates: [{ x: -500, y: -800 }], speed: 1.5 }],
                defenseLeftCenterBack: [{ coordinates: [{ x: -800, y: -850 }], speed: 1.5 }],
                defenseRightCenterBack: [{ coordinates: [{ x: -700, y: -450 }], speed: 1.5 }],
                defenseRightBack: [{ coordinates: [{ x: -650, y: 400 }], speed: 1.5 }],
                defenseLeftMidfield: [{ coordinates: [{ x: 0, y: -650 }], speed: 1.5 }],
                defenseLeftCenterMidfield: [{ coordinates: [{ x: -350, y: -400 }], speed: 1.5 }],
                defenseRightCenterMidfield: [{ coordinates: [{ x: -325, y: 150 }, { x: -525, y: 150 }], speed: 1.5 }],
                defenseRightMidfield: [{ coordinates: [{ x: -350, y: 400 }], speed: 1.5 }],
                defenseLeftForward: [{ coordinates: [{ x: 50, y: -300 }], speed: 1.5 }],
                defenseRightForward: [{ coordinates: [{ x: 0, y: 150 }], speed: 1.5 }],
                offenseRightBack: [{ coordinates: [{ x: 275, y: -600 }], speed: 1.5 }],
                offenseRightCenterBack: [{ coordinates: [{ x: 325, y: -275 }], speed: 1.5 }],
                offenseLeftCenterBack: [{ coordinates: [{ x: 300, y: 50 }], speed: 1.5 }],
                offenseLeftBack: [{ coordinates: [{ x: 275, y: 475 }], speed: 1.5 }],
                offenseRightMidfield: [{ coordinates: [{ x: -250, y: -850 }], speed: 1.5 }],
                offenseRightCenterMidfield: [{ coordinates: [{ x: -250, y: 50 }], speed: 1.5 }],
                offenseLeftCenterMidfield: [{ coordinates: [{ x: -400, y: 250 }, { x: -650, y: 50 }], speed: 1.5 }],
                offenseLeftMidfield: [{ coordinates: [{ x: -650, y: 650 }], speed: 1.5 }],
                offenseRightForward: [{ coordinates: [{ x: -900, y: -1050 }], speed: 1.5 }],
                offenseLeftForward: [{ coordinates: [{ x: -575, y: -550 }], speed: 1.5 }],
                ball: [{ coordinates: [{ x: -950, y: -975 }], speed: 1.5 }],
                offenseGoalKeeper: [{ coordinates: [{ x: 950, y: -250 }], speed: 1.5 }],
                defenseGoalKeeper: [{ coordinates: [{ x: -950, y: -375 }], speed: 1.5 }],
                sidelineRef: [{ coordinates: [{ x: -750, y: -1200 }], speed: 1.5 }]
            },
            nextStates: [
                { state: "goal4H", trigger: "offenseRightForward" }
            ],
            errorState: "yellow4H",
            playerWithBall: "offenseRightForward"
        },
        goal4A: {
            moves: {
                defenseLeftBack: [{ coordinates: [{ x: -800, y: -575 }], speed: 1 }],
                defenseLeftCenterBack: [{ coordinates: [{ x: -750, y: 50 }], speed: 1 }],
                defenseRightCenterBack: [{ coordinates: [{ x: -725, y: 450 }], speed: 1 }],
                defenseRightBack: [{ coordinates: [{ x: -850, y: 675 }], speed: 1 }],
                defenseLeftMidfield: [{ coordinates: [{ x: -450, y: -650 }], speed: 1 }],
                defenseLeftCenterMidfield: [{ coordinates: [{ x: -425, y: -250 }], speed: 1 }],
                defenseRightCenterMidfield: [{ coordinates: [{ x: -450, y: 225 }], speed: 1 }],
                defenseRightMidfield: [{ coordinates: [{ x: -400, y: 650 }], speed: 1 }],
                defenseLeftForward: [{ coordinates: [{ x: 0, y: -100 }], speed: 1 }],
                defenseRightForward: [{ coordinates: [{ x: 0, y: 700 }], speed: 1 }],
                offenseRightBack: [{ coordinates: [{ x: 25, y: -750 }], speed: 1 }],
                offenseRightCenterBack: [{ coordinates: [{ x: 150, y: -200 }], speed: 1 }],
                offenseLeftCenterBack: [{ coordinates: [{ x: 350, y: 400 }], speed: 1 }],
                offenseLeftBack: [{ coordinates: [{ x: 275, y: 800 }], speed: 1 }],
                offenseRightMidfield: [{ coordinates: [{ x: -650, y: -700 }], speed: 1 }],
                offenseRightCenterMidfield: [{ coordinates: [{ x: -700, y: 125 }], speed: 1 }],
                offenseLeftCenterMidfield: [{ coordinates: [{ x: -900, y: 750 }], speed: 1 }],
                offenseLeftMidfield: [{ coordinates: [{ x: -300, y: 350 }], speed: 1 }],
                offenseRightForward: [{ coordinates: [{ x: -700, y: -350 }], speed: 1 }],
                offenseLeftForward: [{ coordinates: [{ x: -650, y: 575 }], speed: 1 }],
                ball: [{ coordinates: [{ x: -935, y: 825 }, { x: -1000, y: 350 }, { x: -900, y: -150 }, {x:-760,y:-300}, { x: -750, y: -300 }, {x:-760,y:-300},{ x: -1000, y: -300 }], speed: 1.1 }],
                offenseGoalKeeper: [{ coordinates: [{ x: 950, y: 50 }],speed:1 }],
                defenseGoalKeeper: [{ coordinates: [{ x: -950, y: -200 }], speed: 0.8 }],
                sidelineRef: [{ coordinates: [{ x: -750, y: -1200 }],speed: 1 }]
            },
            nextStates: [
                { state: "zoomInOnGoal_DiveRight" }
            ],
            playerWithBall: "offenseLeftCenterMidfield",
            advanceOnCompletion: true
        },
        goal4B: {
            moves: {
                defenseLeftBack: [{ coordinates: [{ x: -700, y: -600 }], speed: 0.25 }],
                defenseLeftCenterBack: [{ coordinates: [{ x: -800, y: -150 }], speed: 0.25 }],
                defenseRightCenterBack: [{ coordinates: [{ x: -800, y: 200 }], speed: 0.25 }],
                defenseRightBack: [{ coordinates: [{ x: -600, y: 550 }], speed: 0.25 }],
                defenseLeftMidfield: [{ coordinates: [{ x: -350, y: -550 }], speed: 0.25 }],
                defenseLeftCenterMidfield: [{ coordinates: [{ x: -425, y: -150 }], speed: 0.25 }],
                defenseRightCenterMidfield: [{ coordinates: [{ x: -450, y: 200 }], speed: 0.25 }],
                defenseRightMidfield: [{ coordinates: [{ x: -500, y: 550 }], speed: 0.25 }],
                defenseLeftForward: [{ coordinates: [{ x: -100, y: -75 }], speed: 0.25 }],
                defenseRightForward: [{ coordinates: [{ x: -50, y: 300 }], speed: 0.25 }],
                offenseRightBack: [{ coordinates: [{ x: 25, y: -700 }], speed: 0.25 }],
                offenseRightCenterBack: [{ coordinates: [{ x: 150, y: -210 }], speed: 0.25 }],
                offenseLeftCenterBack: [{ coordinates: [{ x: 200, y: 200 }], speed: 0.25 }],
                offenseLeftBack: [{ coordinates: [{ x: 125, y: 650 }], speed: 0.25 }],
                offenseRightMidfield: [{ coordinates: [{ x: -550, y: -700 }], speed: 0.25 }],
                offenseRightCenterMidfield: [{ coordinates: [{ x: -750, y: 0 }], speed: 0.25 }],
                offenseLeftCenterMidfield: [{ coordinates: [{ x: -700, y: 350 }], speed: 0.25 }],
                offenseLeftMidfield: [{ coordinates: [{ x: -400, y: 400 }], speed: 0.25 }],
                offenseRightForward: [{ coordinates: [{ x: -700, y: -400 }], speed: 0.25 }],
                offenseLeftForward: [{ coordinates: [{ x: -650, y: 800 }], speed: 0.25 }],
                ball: [{ coordinates: [{ x: -975, y: 60 }], speed: 0.25 }],
                offenseGoalKeeper: [{ coordinates: [{ x: 950, y: 50 }], speed: 0.25 }],
                defenseGoalKeeper: [{ coordinates: [{ x: -950, y: -25 }], speed: 0.25 }],
                sidelineRef: [{ coordinates: [{ x: -750, y: -1200 }], speed:0.25 }]
            },
            nextStates: [
                { state: "zoomInOnGoal_DiveLeft" }
            ],
            playerWithBall: "offenseRightCenterMidfield",
            advanceOnCompletion: true
        },
        goal4C: {
            moves: {
                defenseLeftBack: [{ coordinates: [{ x: -775, y: -650 }], speed: 0.25 }],
                defenseLeftCenterBack: [{ coordinates: [{ x: -725, y: -300 }], speed: 0.25 }],
                defenseRightCenterBack: [{ coordinates: [{ x: -725, y: 150 }], speed: 0.25 }],
                defenseRightBack: [{ coordinates: [{ x: -700, y: 400 }], speed: 0.25 }],
                defenseLeftMidfield: [{ coordinates: [{ x: -525, y: -750 }], speed: 0.25 }],
                defenseLeftCenterMidfield: [{ coordinates: [{ x: -500, y: -100 }], speed: 0.25 }],
                defenseRightCenterMidfield: [{ coordinates: [{ x: -550, y: 50 }], speed: 0.25 }],
                defenseRightMidfield: [{ coordinates: [{ x: -375, y: 550 }], speed: 0.25 }],
                defenseLeftForward: [{ coordinates: [{ x: -250, y: -50 }], speed: 0.25 }],
                defenseRightForward: [{ coordinates: [{ x: -250, y: 300 }], speed: 0.25 }],
                offenseRightBack: [{ coordinates: [{ x: 25, y: -700 }], speed: 0.25 }],
                offenseRightCenterBack: [{ coordinates: [{ x: 100, y: -200 }], speed: 0.25 }],
                offenseLeftCenterBack: [{ coordinates: [{ x: 100, y: 200 }], speed: 0.25 }],
                offenseLeftBack: [{ coordinates: [{ x: 125, y: 650 }], speed: 0.25 }],
                offenseRightMidfield: [{ coordinates: [{ x: -575, y: -625 }], speed: 0.25 }],
                offenseRightCenterMidfield: [{ coordinates: [{ x: -425, y: -600 }], speed: 0.25 }],
                offenseLeftCenterMidfield: [{ coordinates: [{ x: -525, y: 275 }], speed: 0.25 }],
                offenseLeftMidfield: [{ coordinates: [{ x: -600, y: 575 }], speed: 0.25 }],
                offenseRightForward: [{ coordinates: [{ x: -575, y: -375 }], speed: 0.25 }],
                offenseLeftForward: [{ coordinates: [{ x: -675, y: 50 }], speed: 0.25 }],
                ball: [{ coordinates: [{ x: -1000, y: -450 }], speed: 0.25 }],
                offenseGoalKeeper: [{ coordinates: [{ x: 950, y: 50 }], speed: 0.25 }],
                defenseGoalKeeper: [{ coordinates: [{ x: -950, y: -150 }], speed: 0.25 }],
                sidelineRef: [{ coordinates: [{ x: -750, y: -1200 }], speed:0.25 }]
            },
            nextStates: [
                { state: "zoomInOnGoal_DiveRight" }
            ],
            playerWithBall: "offenseLeftForward",
            advanceOnCompletion: true
        },
        goal4D: {
            moves: {
                defenseLeftBack: [{ coordinates: [{ x: -750, y: -450 }], speed: 0.25 }],
                defenseLeftCenterBack: [{ coordinates: [{ x: -750, y: -25 }], speed: 0.25 }],
                defenseRightCenterBack: [{ coordinates: [{ x: -775, y: 200 }], speed: 0.25 }],
                defenseRightBack: [{ coordinates: [{ x: -775, y: 500 }], speed: 0.25 }],
                defenseLeftMidfield: [{ coordinates: [{ x: -400, y: -650 }], speed: 0.25 }],
                defenseLeftCenterMidfield: [{ coordinates: [{ x: -550, y: -250 }], speed: 0.25 }],
                defenseRightCenterMidfield: [{ coordinates: [{ x: -500, y: 75 }], speed: 0.25 }],
                defenseRightMidfield: [{ coordinates: [{ x: -400, y: 475 }], speed: 0.25 }],
                defenseLeftForward: [{ coordinates: [{ x: -200, y: 0 }], speed: 0.25 }],
                defenseRightForward: [{ coordinates: [{ x: -225, y: 300 }], speed: 0.25 }],
                offenseRightBack: [{ coordinates: [{ x: 0, y: -700 }], speed: 0.25 }],
                offenseRightCenterBack: [{ coordinates: [{ x: 100, y: -200 }], speed: 0.25 }],
                offenseLeftCenterBack: [{ coordinates: [{ x: 100, y: 200 }], speed: 0.25 }],
                offenseLeftBack: [{ coordinates: [{ x: 125, y: 650 }], speed: 0.25 }],
                offenseRightMidfield: [{ coordinates: [{ x: -675, y: -550 }], speed: 0.25 }],
                offenseRightCenterMidfield: [{ coordinates: [{ x: -425, y: -400 }], speed: 0.25 }],
                offenseLeftCenterMidfield: [{ coordinates: [{ x: -425, y: 200 }], speed: 0.25 }],
                offenseLeftMidfield: [{ coordinates: [{ x: -625, y: 575 }], speed: 0.25 }],
                offenseRightForward: [{ coordinates: [{ x: -675, y: 50 }], speed: 0.25 }],
                offenseLeftForward: [{ coordinates: [{ x: -600, y: 325 }], speed: 0.25 }],
                ball: [{ coordinates: [{ x: -995, y: -85 }], speed: 0.25 }],
                offenseGoalKeeper: [{ coordinates: [{ x: 950, y: 50 }], speed: 0.25 }],
                defenseGoalKeeper: [{ coordinates: [{ x: -950, y: 0 }], speed: 0.25 }],
                sidelineRef: [{ coordinates: [{ x: -750, y: -1200 }], speed: 0.25 }]
            },
            nextStates: [
                { state: "zoomInOnGoal_DiveLeft" }
            ],
            playerWithBall: "offenseRightForward",
            advanceOnCompletion: true
        },
        goal4E: {
            moves: {
                defenseLeftBack: [{ coordinates: [{ x: -725, y: -625 }], speed: 1 }],
                defenseLeftCenterBack: [{ coordinates: [{ x: -775, y: -225 }], speed: 1 }],
                defenseRightCenterBack: [{ coordinates: [{ x: -750, y: 250 }], speed: 1 }],
                defenseRightBack: [{ coordinates: [{ x: -625, y: 475 }], speed: 1 }],
                defenseLeftMidfield: [{ coordinates: [{ x: -500, y: -575 }], speed: 1 }],
                defenseLeftCenterMidfield: [{ coordinates: [{ x: -400, y: -175 }], speed: 1 }],
                defenseRightCenterMidfield: [{ coordinates: [{ x: -475, y: 175 }], speed: 1 }],
                defenseRightMidfield: [{ coordinates: [{ x: -400, y: 600 }], speed: 1 }],
                defenseLeftForward: [{ coordinates: [{ x: -200, y: -125 }], speed: 1 }],
                defenseRightForward: [{ coordinates: [{ x: -225, y: 300 }], speed: 1 }],
                offenseRightBack: [{ coordinates: [{ x: 25, y: -750 }], speed: 1 }],
                offenseRightCenterBack: [{ coordinates: [{ x: -25, y: -250 }], speed: 1 }],
                offenseLeftCenterBack: [{ coordinates: [{ x: 0, y: 150 }], speed: 1 }],
                offenseLeftBack: [{ coordinates: [{ x: 25, y: 400 }], speed: 1 }],
                offenseRightMidfield: [{ coordinates: [{ x: -810, y: -450 }], speed: 0.75 }],
                offenseRightCenterMidfield: [{ coordinates: [{ x: -525, y: -125 }], speed: 1 }],
                offenseLeftCenterMidfield: [{ coordinates: [{ x: -425, y: 375 }], speed: 1 }],
                offenseLeftMidfield: [{ coordinates: [{ x: -500, y: 775 }], speed: 1 }],
                offenseRightForward: [{ coordinates: [{ x: -675, y: 75 }], speed: 1 }],
                offenseLeftForward: [{ coordinates: [{ x: -750, y: 450 }], speed: 1 }],
                ball: [{ coordinates: [{x:-850, y:-300},{ x: -850, y: -325 },{x:-860,y:-325},{ x: -950, y: -325 }], speed: 0.9 }],
                offenseGoalKeeper: [{ coordinates: [{ x: 950, y: 50 }], speed: 0.8 }],
                defenseGoalKeeper: [{ coordinates: [{ x: -950, y: -250 }], speed: 0.8 }],
                sidelineRef: [{ coordinates: [{ x: -750, y: -1200 }], speed: 1 }]
            },
            nextStates: [
                { state: "zoomInOnGoal_DiveRight" }
            ],
            playerWithBall: "offenseLeftForward",
            advanceOnCompletion: true
        },
        goal4F: {
            moves: {
                defenseLeftBack: [{ coordinates: [{ x: -775, y: -600 }], speed: 0.25 }],
                defenseLeftCenterBack: [{ coordinates: [{ x: -725, y: -225 }], speed: 0.25 }],
                defenseRightCenterBack: [{ coordinates: [{ x: -750, y: 125 }], speed: 0.25 }],
                defenseRightBack: [{ coordinates: [{ x: -725, y: 450 }], speed: 0.25 }],
                defenseLeftMidfield: [{ coordinates: [{ x: -500, y: -550 }], speed: 0.25 }],
                defenseLeftCenterMidfield: [{ coordinates: [{ x: -500, y: -200 }], speed: 0.25 }],
                defenseRightCenterMidfield: [{ coordinates: [{ x: -500, y: 125 }], speed: 0.25 }],
                defenseRightMidfield: [{ coordinates: [{ x: -450, y: 550 }], speed: 0.25 }],
                defenseLeftForward: [{ coordinates: [{ x: -150, y: -250 }], speed: 0.25 }],
                defenseRightForward: [{ coordinates: [{ x: -100, y: 300 }], speed: 0.25 }],
                offenseRightBack: [{ coordinates: [{ x: 0, y: -650 }], speed: 0.25 }],
                offenseRightCenterBack: [{ coordinates: [{ x: -25, y: -250 }], speed: 0.25 }],
                offenseLeftCenterBack: [{ coordinates: [{ x: 250, y: 75 }], speed: 0.25 }],
                offenseLeftBack: [{ coordinates: [{ x: -75, y: 250 }], speed: 0.25 }],
                offenseRightMidfield: [{ coordinates: [{ x: -675, y: -500 }], speed: 0.25 }],
                offenseRightCenterMidfield: [{ coordinates: [{ x: -450, y: -50 }], speed: 0.25 }],
                offenseLeftCenterMidfield: [{ coordinates: [{ x: -400, y: 275 }], speed: 0.25 }],
                offenseLeftMidfield: [{ coordinates: [{ x: -675, y: 625 }], speed: 0.25 }],
                offenseRightForward: [{ coordinates: [{ x: -750, y: -100 }], speed: 0.25 }],
                offenseLeftForward: [{ coordinates: [{ x: -625, y: 300 }], speed: 0.25 }],
                ball: [{ coordinates: [{ x: -975, y: 75 }], speed: 0.25 }],
                offenseGoalKeeper: [{ coordinates: [{ x: 950, y: 50 }],speed: 0.25 }],
                defenseGoalKeeper: [{ coordinates: [{ x: -950, y: -50 }], speed: 0.25 }],
                sidelineRef: [{ coordinates: [{ x: -750, y: -1200 }], speed: 0.25 }]
            },
            nextStates: [
                { state: "zoomInOnGoal_DiveLeft" }
            ],
            playerWithBall: "offenseRightForward",
            advanceOnCompletion: true
        },
        goal4G: {
            moves: {
                defenseLeftBack: [{ coordinates: [{ x: -700, y: -775 }], speed: 1 }],
                defenseLeftCenterBack: [{ coordinates: [{ x: -800, y: -450 }], speed: 1 }],
                defenseRightCenterBack: [{ coordinates: [{ x: -700, y: -100 }], speed: 1 }],
                defenseRightBack: [{ coordinates: [{ x: -700, y: 300 }], speed: 1 }],
                defenseLeftMidfield: [{ coordinates: [{ x: -350, y: -700 }], speed: 1 }],
                defenseLeftCenterMidfield: [{ coordinates: [{ x: -400, y: -425 }], speed: 1 }],
                defenseRightCenterMidfield: [{ coordinates: [{ x: -475, y: 50 }], speed: 1 }],
                defenseRightMidfield: [{ coordinates: [{ x: -400, y: 400 }], speed: 1 }],
                defenseLeftForward: [{ coordinates: [{ x: -50, y: -200 }], speed: 1 }],
                defenseRightForward: [{ coordinates: [{ x: -100, y: 150 }], speed: 1 }],
                offenseRightBack: [{ coordinates: [{ x: 175, y: -600 }], speed: 1 }],
                offenseRightCenterBack: [{ coordinates: [{ x: 225, y: -200 }], speed: 1 }],
                offenseLeftCenterBack: [{ coordinates: [{ x: 200, y: 100 }], speed: 1 }],
                offenseLeftBack: [{ coordinates: [{ x: 75, y: 300 }], speed: 1 }],
                offenseRightMidfield: [{ coordinates: [{ x: -550, y: -850 }], speed: 1 }],
                offenseRightCenterMidfield: [{ coordinates: [{ x: -300, y: -200 }], speed: 1 }],
                offenseLeftCenterMidfield: [{ coordinates: [{ x: -600, y: 150 }], speed: 0.75 }],
                offenseLeftMidfield: [{ coordinates: [{ x: -650, y: 550 }], speed: 1 }],
                offenseRightForward: [{ coordinates: [{ x: -700, y: -600 }], speed: 1 }],
                offenseLeftForward: [{ coordinates: [{ x: -600, y: -400 }], speed: 1 }],
                ball: [{ coordinates: [{x:-650,y:150}, { x: -650, y: 200 }, {x:-660,y:190},{ x: -950, y: 150 }], speed: 0.9}],
                offenseGoalKeeper: [{ coordinates: [{ x: 950, y: 50 }],speed: 0.8 }],
                defenseGoalKeeper: [{ coordinates: [{ x: -950, y: -25 }], speed: 0.8 }],
                sidelineRef: [{ coordinates: [{ x: -750, y: -1200 }], speed: 1 }]
            },
            nextStates: [
                { state: "zoomInOnGoal_DiveLeft" }
            ],
            playerWithBall: "offenseLeftForward",
            advanceOnCompletion: true
        },
        goal4H: {
            moves: {
                defenseLeftBack: [{ coordinates: [{ x: -500, y: -700 }], speed: 1 }],
                defenseLeftCenterBack: [{ coordinates: [{ x: -850, y: -850 }], speed: 1 }],
                defenseRightCenterBack: [{ coordinates: [{ x: -800, y: -350 }], speed: 1 }],
                defenseRightBack: [{ coordinates: [{ x: -750, y: 300 }], speed: 1 }],
                defenseLeftMidfield: [{ coordinates: [{ x: -300, y: -550 }], speed: 1 }],
                defenseLeftCenterMidfield: [{ coordinates: [{ x: -450, y: -300 }], speed: 1 }],
                defenseRightCenterMidfield: [{ coordinates: [{ x: -625, y: 50 }], speed: 1 }],
                defenseRightMidfield: [{ coordinates: [{ x: -450, y: 375 }], speed: 1 }],
                defenseLeftForward: [{ coordinates: [{ x: -50, y: -200 }], speed: 1 }],
                defenseRightForward: [{ coordinates: [{ x: -100, y: 100 }], speed: 1 }],
                offenseRightBack: [{ coordinates: [{ x: 175, y: -500 }], speed: 1 }],
                offenseRightCenterBack: [{ coordinates: [{ x: 225, y: -175 }], speed: 1 }],
                offenseLeftCenterBack: [{ coordinates: [{ x: 200, y: 75 }], speed: 1 }],
                offenseLeftBack: [{ coordinates: [{ x: 175, y: 375 }], speed: 1 }],
                offenseRightMidfield: [{ coordinates: [{ x: -350, y: -750 }], speed: 1 }],
                offenseRightCenterMidfield: [{ coordinates: [{ x: -400, y: 75 }], speed: 1 }],
                offenseLeftCenterMidfield: [{ coordinates: [{ x: -750, y: 75 }], speed: 0.75 }],
                offenseLeftMidfield: [{ coordinates: [{ x: -750, y: 550 }], speed: 1 }],
                offenseRightForward: [{ coordinates: [{ x: -900, y: -1050 }], speed: 1 }],
                offenseLeftForward: [{ coordinates: [{ x: -675, y: -450 }], speed: 1 }],
                ball: [{ coordinates: [{x:-800,y:140},{ x: -800, y: 150 },{x:-810,y:150},{ x: -950, y: 150 }], speed: 0.9 }],
                offenseGoalKeeper: [{ coordinates: [{ x: 950, y: 50 }], speed: 1 }],
                defenseGoalKeeper: [{ coordinates: [{ x: -950, y: -25 }], speed: 0.8 }],
                sidelineRef: [{ coordinates: [{ x: -750, y: -1200 }], speed: 1 }]
            },
            nextStates: [
                { state: "zoomInOnGoal_DiveLeft" }
            ],
            playerWithBall: "offenseRightForward",
            advanceOnCompletion: true
        },
        yellow1: {
            moves: {
                defenseLeftBack: [{ coordinates: [{ x: -550, y: -700 }], speed: 1.25 }],
                defenseLeftCenterBack: [{ coordinates: [{ x: -550, y: -300 }], speed: 1.25 }],
                defenseRightCenterBack: [{ coordinates: [{ x: -500, y: 225 }], speed: 1.25 }],
                defenseRightBack: [{ coordinates: [{ x: -475, y: 560 }], speed: 1.25 }],
                defenseLeftMidfield: [{ coordinates: [{ x: -25, y: -800 }], speed: 1.25 }],
                defenseLeftCenterMidfield: [{ coordinates: [{ x: -150, y: -450 }], speed: 1.25 }],
                defenseRightCenterMidfield: [{ coordinates: [{ x: 100, y: 50 }], speed: 1.25 }],
                defenseRightMidfield: [{ coordinates: [{ x: 50, y: 550 }], speed: 1.25 }],
                defenseLeftForward: [{ coordinates: [{ x: 600, y: -50 }], speed: 1.25 }],
                defenseRightForward: [{ coordinates: [{ x: 325, y: 625 }, { x: 425, y: 625 }], speed: 1 }],
                offenseRightBack: [{ coordinates: [{ x: 750, y: -775 }], speed: 1.25 }],
                offenseRightCenterBack: [{ coordinates: [{ x: 700, y: -225 }], speed: 1.25 }],
                offenseLeftCenterBack: [{ coordinates: [{ x: 700, y: 225 }], speed: 1.25 }],
                offenseLeftBack: [{ coordinates: [{ x: 600, y: 600 }], speed: 1.25 }],
                offenseRightMidfield: [{ coordinates: [{ x: 350, y: -750 }], speed: 1.25 }],
                offenseRightCenterMidfield: [{ coordinates: [{ x: 200, y: -300 }], speed: 1.25 }],
                offenseLeftCenterMidfield: [{ coordinates: [{ x: 325, y: 100 }], speed: 1.25 }],
                offenseLeftMidfield: [{ coordinates: [{ x: 300, y: 600 }], speed: 1.25 }],
                offenseRightForward: [{ coordinates: [{ x: -250, y: -200 }], speed: 1.25 }],
                offenseLeftForward: [{ coordinates: [{ x: -100, y: 275 }], speed: 1.25 }],
                ball: [{ coordinates: [{x:385,y:700},{ x: 375, y: 700 },{x:385,y:690},{ x: 650, y: 50 }], speed: 1.25 }],
                offenseGoalKeeper: [{ coordinates: [{ x: 950, y: -100 }], speed: 1.25 }],
                defenseGoalKeeper: [{ coordinates: [{ x: -950, y: -150 }], speed: 1.25 }],
                sidelineRef: [{ coordinates: [{ x: 350, y: -1200 }], speed: 1.25 }]
            },
            nextStates: [
                { state: "yellow1to2B", trigger: "defenseLeftForward" }
            ],
            errorState: "red",
            playerWithBall: "defenseLeftForward"
        },
        yellow1to2B: {
            moves: {
                defenseLeftBack: [{ coordinates: [{ x: -400, y: -850 }], speed: 1.25 }],
                defenseLeftCenterBack: [{ coordinates: [{ x: -500, y: -425 }], speed: 1.25 }],
                defenseRightCenterBack: [{ coordinates: [{ x: -450, y: 250 }], speed: 1.25 }],
                defenseRightBack: [{ coordinates: [{ x: -350, y: 500 }], speed: 1.25 }],
                defenseLeftMidfield: [{ coordinates: [{ x: 300, y: -800 }], speed: 1.25 }],
                defenseLeftCenterMidfield: [{ coordinates: [{ x: -50, y: -500 }], speed: 1.25 }],
                defenseRightCenterMidfield: [{ coordinates: [{ x: 0, y: 50 }], speed: 1.25 }],
                defenseRightMidfield: [{ coordinates: [{ x: 150, y: 550 }], speed: 1.25 }],
                defenseLeftForward: [{ coordinates: [{ x: 550, y: -400 }], speed: 1.25 }],
                defenseRightForward: [{ coordinates: [{ x: 400, y: 300 }], speed: 1.25 }],
                offenseRightBack: [{ coordinates: [{ x: 575, y: -900 }], speed: 1.25 }],
                offenseRightCenterBack: [{ coordinates: [{ x: 725, y: -375 }], speed: 1.25 }],
                offenseLeftCenterBack: [{ coordinates: [{ x: 700, y: 150 }], speed: 1.25 }],
                offenseLeftBack: [{ coordinates: [{ x: 675, y: 575 }], speed: 1.25 }],
                offenseRightMidfield: [{ coordinates: [{ x: 50, y: -950 }], speed: 1.25 }],
                offenseRightCenterMidfield: [{ coordinates: [{ x: 300, y: -350 }], speed: 1.25 }],
                offenseLeftCenterMidfield: [{ coordinates: [{ x: 150, y: 200 }], speed: 1.25 }],
                offenseLeftMidfield: [{ coordinates: [{ x: 50, y: 750 }], speed: 1.25 }],
                offenseRightForward: [{ coordinates: [{ x: -250, y: -400 }], speed: 1.25 }],
                offenseLeftForward: [{ coordinates: [{ x: -200, y: 200 }], speed: 1.25 }],
                ball: [{ coordinates: [{ x: 1000, y: -500 }, {x:990,y:-500},{ x: 950, y: -850 }, { x: 700, y: -1000 }, { x: 600, y: -900 }, { x: 500, y: -825 }], speed: 0.85 }],
                offenseGoalKeeper: [{ coordinates: [{x:1000,y:-400},{ x: 950, y: -350 }], speed: 0.75 }],
                defenseGoalKeeper: [{ coordinates: [{ x: -950, y: -200 }], speed: 1.25 }],
                sidelineRef: [{ coordinates: [{ x: 400, y: -1200 }], speed:1.25 }]
            },
            nextStates: [
                { state: "question3C", trigger: "offenseRightCenterMidfield" },
                { state: "question3D", trigger: "offenseRightMidfield" }
            ],
            errorState: "red",
            playerWithBall: "offenseRightBack",
            soundFX: "cheer"
        },
        yellow2A: {
            moves: {
                defenseLeftBack: [{ coordinates: [{ x: -450, y: -650 }], speed: 1.25 }],
                defenseLeftCenterBack: [{ coordinates: [{ x: -450, y: -200 }], speed: 1.25 }],
                defenseRightCenterBack: [{ coordinates: [{ x: -400, y: 200 }], speed: 1.25 }],
                defenseRightBack: [{ coordinates: [{ x: -325, y: 400 }], speed: 1.25 }],
                defenseLeftMidfield: [{ coordinates: [{ x: 200, y: -700 }], speed: 1.25 }],
                defenseLeftCenterMidfield: [{ coordinates: [{ x: 100, y: -450 }], speed: 1.25 }],
                defenseRightCenterMidfield: [{ coordinates: [{ x: 125, y: 175 }], speed: 1.25 }],
                defenseRightMidfield: [{ coordinates: [{ x: 75, y: 600 }, {x:80,y:595},{ x: 300, y: 400 }], speed: 1 }],
                defenseLeftForward: [{ coordinates: [{ x: 450, y: -25 }], speed: 1.25 }],
                defenseRightForward: [{ coordinates: [{ x: 450, y: 700 }], speed: 1.25 }],
                offenseRightBack: [{ coordinates: [{ x: 550, y: -700 }], speed: 1.25 }],
                offenseRightCenterBack: [{ coordinates: [{ x: 600, y: -200 }], speed: 1.25 }],
                offenseLeftCenterBack: [{ coordinates: [{ x: 450, y: 300 }], speed: 1.25 }],
                offenseLeftBack: [{ coordinates: [{ x: 575, y: 550 }], speed: 1.25 }],
                offenseRightMidfield: [{ coordinates: [{ x: 0, y: -700 }], speed: 1.25 }],
                offenseRightCenterMidfield: [{ coordinates: [{ x: 175, y: -300 }], speed: 1.25 }],
                offenseLeftCenterMidfield: [{ coordinates: [{ x: 200, y: 350 }], speed: 1.25 }],
                offenseLeftMidfield: [{ coordinates: [{ x: 150, y: 650 }], speed: 1.25 }],
                offenseRightForward: [{ coordinates: [{ x: -225, y: -100 }], speed: 1.25 }],
                offenseLeftForward: [{ coordinates: [{ x: -50, y: 600 }], speed: 1.25 }],
                ball: [{ coordinates: [{x:130,y:680},{ x: 125, y: 675 },{x:130,y:670},{ x: 350, y: 475 }], speed: .8 }],
                offenseGoalKeeper: [{ coordinates: [{ x: 950, y: 50 }], speed: 1.25 }],
                defenseGoalKeeper: [{ coordinates: [{ x: -950, y: -50 }], speed: 1.25 }],
                sidelineRef: [{ coordinates: [{ x: 200, y: -1200 }], speed: 1.25 }]
            },
            nextStates: [
                { state: "yellow2Ato3C", trigger: "defenseRightMidfield" }
            ],
            errorState: "red",
            playerWithBall: "defenseRightMidfield"
        },
        yellow2Ato3C: {
            moves: {
                defenseLeftBack: [{ coordinates: [{ x: -450, y: -850 }], speed: 1 }],
                defenseLeftCenterBack: [{ coordinates: [{ x: -525, y: -350 }], speed: 1 }],
                defenseRightCenterBack: [{ coordinates: [{ x: -500, y: 150 }], speed: 1 }],
                defenseRightBack: [{ coordinates: [{ x: -400, y: 600 }], speed: 1 }],
                defenseLeftMidfield: [{ coordinates: [{ x: 0, y: -800 }], speed: 1 }],
                defenseLeftCenterMidfield: [{ coordinates: [{ x: -100, y: -300 }], speed: 1 }],
                defenseRightCenterMidfield: [{ coordinates: [{ x: -250, y: 275 }], speed: 1 }],
                defenseRightMidfield: [{ coordinates: [{ x: -50, y: 550 }], speed: 1 }],
                defenseLeftForward: [{ coordinates: [{ x: 350, y: -400 }], speed: 1 }],
                defenseRightForward: [{ coordinates: [{ x: 200, y: 300 }], speed: 1 }],
                offenseRightBack: [{ coordinates: [{ x: 375, y: -900 }], speed: 1 }],
                offenseRightCenterBack: [{ coordinates: [{ x: 525, y: -375 }], speed: 1 }],
                offenseLeftCenterBack: [{ coordinates: [{ x: 425, y: 150 }], speed: 0.5 }, { coordinates: [{x:325,y:150}],speed: 0.5}],
                offenseLeftBack: [{ coordinates: [{ x: 475, y: 575 }], speed: 1 }],
                offenseRightMidfield: [{ coordinates: [{ x: -350, y: -950 }], speed: 1 }],
                offenseRightCenterMidfield: [{ coordinates: [{ x: 0, y: -150 }], speed: 1 }],
                offenseLeftCenterMidfield: [{ coordinates: [{ x: -150, y: 350 }], speed: 1 }],
                offenseLeftMidfield: [{ coordinates: [{ x: -250, y: 750 }], speed: 1 }],
                offenseRightForward: [{ coordinates: [{ x: -350, y: -300 }], speed: 1 }],
                offenseLeftForward: [{ coordinates: [{ x: -400, y: 300 }], speed: 1 }],
                ball: [{ coordinates: [{x:370,y:205},{ x: 375, y: 200 },{x:370,y:195},{ x: -50, y: -50 }], speed: .8 }],
                offenseGoalKeeper: [{ coordinates: [{ x: 950, y: -150 }], speed: 1 }],
                defenseGoalKeeper: [{ coordinates: [{ x: -950, y: -150 }], speed: 1 }],
                sidelineRef: [{ coordinates: [{ x: 0, y: -1200 }], speed: 1 }]
            },
            nextStates: [
                { state: "question4E", trigger: "offenseLeftForward" },
                { state: "question4F", trigger: "offenseRightForward" }
            ],
            errorState: "red",
            playerWithBall: "offenseRightCenterMidfield"
        },
        yellow2B: {
            moves: {
                defenseLeftBack: [{ coordinates: [{ x: -300, y: -750 }], speed: 1 }],
                defenseLeftCenterBack: [{ coordinates: [{ x: -400, y: -325 }], speed: 1 }],
                defenseRightCenterBack: [{ coordinates: [{ x: -350, y: 350 }], speed: 1 }],
                defenseRightBack: [{ coordinates: [{ x: -250, y: 600 }], speed: 1 }],
                defenseLeftMidfield: [{ coordinates: [{ x: 325, y: -700 }], speed: 0.3 }, { coordinates: [{ x: 375, y: -600 }], speed: 0.25 }],
                defenseLeftCenterMidfield: [{ coordinates: [{ x: 50, y: -400 }], speed: 1 }],
                defenseRightCenterMidfield: [{ coordinates: [{ x: 25, y: 50 }], speed: 1 }],
                defenseRightMidfield: [{ coordinates: [{ x: 250, y: 650 }], speed: 1 }],
                defenseLeftForward: [{ coordinates: [{ x: 600, y: -350 }], speed: 1 }],
                defenseRightForward: [{ coordinates: [{ x: 450, y: 300 }], speed: 1 }],
                offenseRightBack: [{ coordinates: [{ x: 625, y: -800 }], speed: 1 }],
                offenseRightCenterBack: [{ coordinates: [{ x: 725, y: -350 }], speed: 1 }],
                offenseLeftCenterBack: [{ coordinates: [{ x: 650, y: 150 }], speed: 1 }],
                offenseLeftBack: [{ coordinates: [{ x: 650, y: 550 }], speed: 1 }],
                offenseRightMidfield: [{ coordinates: [{ x: 150, y: -850 }], speed: 1 }],
                offenseRightCenterMidfield: [{ coordinates: [{ x: 325, y: -300 }], speed: 1 }],
                offenseLeftCenterMidfield: [{ coordinates: [{ x: 250, y: 200 }], speed: 1 }],
                offenseLeftMidfield: [{ coordinates: [{ x: 150, y: 700 }], speed: 1 }],
                offenseRightForward: [{ coordinates: [{ x: -150, y: -300 }], speed: 1 }],
                offenseLeftForward: [{ coordinates: [{ x: -100, y: 300 }], speed: 1 }],
                ball: [{ coordinates: [{x:405,y:-605}, { x: 400, y: -600 }, {x:405,y:-595},{ x: 500, y: 375 }], speed: .8 }],
                offenseGoalKeeper: [{ coordinates: [{ x: 950, y: 0 }], speed: 1 }],
                defenseGoalKeeper: [{ coordinates: [{ x: -950, y: -100 }], speed: 1 }],
                sidelineRef: [{ coordinates: [{ x: 350, y: -1200 }], speed: 1 }]
            },
            nextStates: [
                { state: "yellow2Bto3B", trigger: "defenseRightForward" }
            ],
            errorState: "red",
            playerWithBall: "defenseRightForward"
        },
        yellow2Bto3B: {
            moves: {
                defenseLeftBack: [{ coordinates: [{ x: -250, y: -700 }], speed: 0.3 }, { coordinates: [{ x: -625, y: -700 }], speed: 1 }],
                defenseLeftCenterBack: [{ coordinates: [{ x: -350, y: -275 }], speed: 0.3 }, { coordinates: [{ x: -650, y: -275 }], speed: 1 }],
                defenseRightCenterBack: [{ coordinates: [{ x: -300, y: 400 }], speed: 0.3 }, { coordinates: [{ x: -600, y: 300 }], speed: 1 }],
                defenseRightBack: [{ coordinates: [{ x: -200, y: 600 }], speed: 0.3 }, { coordinates: [{ x: -450, y: 600 }], speed: 1 }],
                defenseLeftMidfield: [ { coordinates: [{ x: 325, y: -550 }], speed: 0.3}, { coordinates: [{ x: -100, y: -800 }], speed: 1 }],
                defenseLeftCenterMidfield: [{ coordinates: [{ x: 0, y: -400 }], speed: 0.3 }, { coordinates: [{ x: -300, y: -450 }], speed: 1 }],
                defenseRightCenterMidfield: [{ coordinates: [{ x: 50, y: 50 }], speed: 0.3 }, { coordinates: [{ x: -150, y: 100 }], speed: 1 }],
                defenseRightMidfield: [{ coordinates: [{ x: 200, y: 600 }], speed: 0.3 }, { coordinates: [{ x: -50, y: 600 }], speed: 1 }],
                defenseLeftForward: [{ coordinates: [{ x: 650, y: -300 }], speed: 0.3 }, { coordinates: [{ x: 150, y: -125 }], speed :1 }],
                defenseRightForward: [{ coordinates: [{ x: 450, y: 300 }], speed: 0.3 }, { coordinates: [{ x: 150, y: 600 }], speed: 1 }],
                offenseRightBack: [{ coordinates: [{ x: 625, y: -800 }], speed: 0.3 }, { coordinates: [{ x: 275, y: -800 }], speed: 1 }],
                offenseRightCenterBack: [{ coordinates: [{ x: 725, y: -350 }], speed: 0.3 }, { coordinates: [{ x: 400, y: -300 }], speed: 1 }],
                offenseLeftCenterBack: [{ coordinates: [{ x: 575, y: 150 }], speed: 0.5 }, { coordinates: [{ x: 450, y: 125 }], speed: 0.5 }],
                offenseLeftBack: [{ coordinates: [{ x: 650, y: 550 }], speed: 0.3 }, { coordinates: [{ x: 425, y: 750 }], speed: 1 }],
                offenseRightMidfield: [{ coordinates: [{ x: 150, y: -850 }], speed: 0.3 }, { coordinates: [{ x: -450, y: -700 }], speed: 1 }],
                offenseRightCenterMidfield: [{ coordinates: [{ x: 375, y: -275 }], speed: 0.3 }, { coordinates: [{ x: -175, y: -600 }], speed: 1 }],
                offenseLeftCenterMidfield: [{ coordinates: [{ x: 275, y: 225 }], speed: 0.3 }, { coordinates: [{ x: -175, y: 300 }], speed: 1 }],
                offenseLeftMidfield: [{ coordinates: [{ x: 150, y: 700 }], speed: 0.3 }, { coordinates: [{ x: -300, y: 700 }], speed: 1 }],
                offenseRightForward: [{ coordinates: [{ x: -150, y: -300 }], speed: 0.3 }, { coordinates: [{ x: -475, y: -250 }], speed: 1 }],
                offenseLeftForward: [{ coordinates: [{ x: -100, y: 300 }], speed: 0.3 }, { coordinates: [{ x: -450, y: 250 }], speed: 1 }],
                ball: [{ coordinates: [{ x: 525, y: 200 },{ x: 400, y: 175 },{ x: -225, y: 375 }], speed: 1.25 }],
                offenseGoalKeeper: [{ coordinates: [{ x: 950, y: -50 }], speed: 1.25 }],
                defenseGoalKeeper: [{ coordinates: [{ x: -950, y: -150 }], speed: 1.25 }],
                sidelineRef: [{ coordinates: [{ x: 200, y: -1200 }], speed: 0.7 },{ coordinates: [{ x: -150, y: -1200 }], speed: .7 }]
            },
            nextStates: [
                { state: "question4C", trigger: "offenseLeftForward" },
                { state: "question4D", trigger: "offenseRightForward" }
            ],
            errorState: "red",
            playerWithBall: "offenseLeftCenterMidfield"
        },
        yellow3A: {
            moves: {
                defenseLeftBack: [{ coordinates: [{ x: -650, y: -725 }], speed: 1 }, { coordinates: [{ x: -350, y: -700 }], speed:1 }],
                defenseLeftCenterBack: [{ coordinates: [{ x: -850, y: -225 }], speed: 1 }, { coordinates: [{ x: -800, y: -250 }], speed: 1 }],
                defenseRightCenterBack: [{ coordinates: [{ x: -650, y: 150 }], speed:1 }, { coordinates: [{ x: -450, y: 200 }], speed:1 }],
                defenseRightBack: [{ coordinates: [{ x: -400, y: 550 }], speed:1 }, { coordinates: [{ x: -300, y: 600 }], speed:1 }],
                defenseLeftMidfield: [{ coordinates: [{ x: -50, y: -700 }], speed:1 }, { coordinates: [{ x: 250, y: -850 }], speed:1 }],
                defenseLeftCenterMidfield: [{ coordinates: [{ x: -150, y: -350 }], speed: 1.2 }, { coordinates: [{ x: 0, y: -400 }], speed: 0.55 }],
                defenseRightCenterMidfield: [{ coordinates: [{ x: -100, y: 175 }], speed: 1 }, { coordinates: [{ x: 0, y: 150 }], speed:1 }],
                defenseRightMidfield: [{ coordinates: [{ x: 0, y: 600 }], speed:1 }, { coordinates: [{ x: 50, y: 700 }],speed:1 }],
                defenseLeftForward: [{ coordinates: [{ x: 150, y: 0 }], speed:1 }, { coordinates: [{ x: 350, y: -25 }], speed: 1 }],
                defenseRightForward: [{ coordinates: [{ x: 150, y: 450 }], speed:1 }, { coordinates: [{ x: 350, y: 400 }], speed: 1 }],
                offenseRightBack: [{ coordinates: [{ x: 275, y: -700 }], speed: 1 }, { coordinates: [{ x: 325, y: -650 }], speed: 1 }],
                offenseRightCenterBack: [{ coordinates: [{ x: 350, y: -200 }], speed: 1 }, { coordinates: [{ x: 450, y: -150 }], speed: 1 }],
                offenseLeftCenterBack: [{ coordinates: [{ x: 400, y: 200 }], speed: 1 }, { coordinates: [{ x: 450, y: 300 }], speed: 1 }],
                offenseLeftBack: [{ coordinates: [{ x: 425, y: 700 }], speed: 1 }, { coordinates: [{ x: 550, y: 600 }], speed: 1 }],
                offenseRightMidfield: [{ coordinates: [{ x: -300, y: -700 }], speed: 1 }, { coordinates: [{ x: -200, y: -750 }], speed: 1 }],
                offenseRightCenterMidfield: [{ coordinates: [{ x: -425, y: -75 }], speed: 1 }, { coordinates: [{ x: -200, y: -150 }], speed: 1 }],
                offenseLeftCenterMidfield: [{ coordinates: [{ x: -475, y: 400 }], speed: 1 }, { coordinates: [{ x: -250, y: 300 }], speed: 1 }],
                offenseLeftMidfield: [{ coordinates: [{ x: -50, y: 425 }], speed: 1 }, { coordinates: [{ x: -10, y: 350 }], speed: 1 }],
                offenseRightForward: [{ coordinates: [{ x: -700, y: -400 }], speed: 1 }, { coordinates: [{ x: -600, y: -250 }], speed: 1 }],
                offenseLeftForward: [{ coordinates: [{ x: -300, y: 800 }], speed: 0.5 }, { coordinates: [{ x: -100, y: 650 }], speed: 1 }],
                ball: [{ coordinates: [{ x: -450, y: 775 }, { x: -600, y: 375 }, { x: -775, y: -175 }], speed: 1.25 }, { coordinates: [{x:-375,y:-350},{ x: 75, y: -300 }], speed: 0.5 }],
                offenseGoalKeeper: [{ coordinates: [{ x: 950, y: -200 }], speed: 1.75 }],
                defenseGoalKeeper: [{ coordinates: [{ x: -950, y: -200 }], speed: 1.75 }],
                sidelineRef: [{ coordinates: [{x:-550, y:-1200}], speed:1.25}, { coordinates: [{ x: -150, y: -1200 }], speed: 0.5 }]
            },
            nextStates: [
                { state: "yellow3Ato4H", trigger: "defenseLeftCenterMidfield" }
            ],
            errorState: "red",
            playerWithBall: "defenseLeftCenterMidfield"
        },
        yellow3Ato4H: {
            moves: {
                defenseLeftBack: [{ coordinates: [{ x: -175, y: -550 }], speed: 0.75 }, { coordinates: [{ x: -500, y: -800 }], speed: 1.25 }],
                defenseLeftCenterBack: [{ coordinates: [{ x: -700, y: -250 }], speed: 1 }, { coordinates: [{ x: -800, y: -850 }], speed: 1 }],
                defenseRightCenterBack: [{ coordinates: [{ x: -350, y: 150 }], speed: 1 }, { coordinates: [{ x: -700, y: -450 }], speed: 1 }],
                defenseRightBack: [{ coordinates: [{ x: -200, y: 500 }], speed: 1 }, { coordinates: [{ x: -650, y: 400 }], speed: 1 }],
                defenseLeftMidfield: [{ coordinates: [{ x: 450, y: -850 }], speed: 0.5 }, { coordinates: [{ x: 0, y: -650 }], speed: 1.5 }],
                defenseLeftCenterMidfield: [{ coordinates: [{ x: 0, y: -400 }], speed: 0.5 }, { coordinates: [{ x: -350, y: -400 }], speed: 1.5 }],
                defenseRightCenterMidfield: [{ coordinates: [{ x: 100, y: 100 }], speed: 1 }, { coordinates: [{ x: -325, y: 150 }, { x: -525, y: 150 }], speed: 1 }],
                defenseRightMidfield: [{ coordinates: [{ x: 50, y: 600 }], speed: 1 }, { coordinates: [{ x: -350, y: 400 }], speed: 1 }],
                defenseLeftForward: [{ coordinates: [{ x: 400, y: -75 }], speed: 1 }, { coordinates: [{ x: 50, y: -300 }], speed: 1 }],
                defenseRightForward: [{ coordinates: [{ x: 375, y: 250 }], speed: 1 }, { coordinates: [{ x: 0, y: 150 }], speed: 1 }],
                offenseRightBack: [{ coordinates: [{ x: 500, y: -600 }], speed: 0.5 }, { coordinates: [{ x: 275, y: -600 }], speed: 1 }],
                offenseRightCenterBack: [{ coordinates: [{ x: 500, y: -250 }], speed: 1 }, { coordinates: [{ x: 325, y: -275 }], speed: 1 }],
                offenseLeftCenterBack: [{ coordinates: [{ x: 500, y: 275 }], speed: 1 }, { coordinates: [{ x: 300, y: 50 }], speed: 1 }],
                offenseLeftBack: [{ coordinates: [{ x: 600, y: 525 }], speed: 1 }, { coordinates: [{ x: 275, y: 475 }], speed: 1 }],
                offenseRightMidfield: [{ coordinates: [{ x: -150, y: -700 }], speed: 0.75 }, { coordinates: [{ x: -250, y: -850 }], speed: 1 }],
                offenseRightCenterMidfield: [{ coordinates: [{ x: -100, y: -150 }], speed: 1.25 }, { coordinates: [{ x: -250, y: 50 }], speed: 0.75 }],
                offenseLeftCenterMidfield: [{ coordinates: [{ x: -275, y: 250 }], speed: 0.75 }, { coordinates: [{ x: -400, y: 250 }, { x: -650, y: 50 }], speed: 1.25 }],
                offenseLeftMidfield: [{ coordinates: [{ x: 100, y: 350 }], speed: 1 }, { coordinates: [{ x: -650, y: 650 }], speed: 1 }],
                offenseRightForward: [{ coordinates: [{ x: -500, y: -450 },{ x: -900, y: -1050 }], speed: 2 }],
                offenseLeftForward: [{ coordinates: [{ x: -150, y: 250 }], speed: 0.75 }, { coordinates: [{ x: -475, y: -450 }], speed: 1.25 }],
                ball: [{ coordinates: [{x:445,y:-450},{ x: 450, y: -450 }, { x: 445, y: -455 }, {x:345, y:-600}, {x:245, y:-750}, { x: -50, y: -1000 }, { x: -350, y: -1100 }, { x: -650, y: -1050 }, { x: -950, y: -950 }], speed: 1.75 }],
                offenseGoalKeeper: [{ coordinates: [{ x: 950, y: -250 }] }],
                defenseGoalKeeper: [{ coordinates: [{ x: -950, y: -350 }] }],
                sidelineRef: [{ coordinates: [{x:150,y:-1200}], speed:0.75},{ coordinates: [{ x: -650, y: -1200 }], speed:1.25 }]
            },
            nextStates: [
                { state: "goal4H", trigger: "offenseRightForward" }
            ],
            errorState: "red",
            playerWithBall: "offenseRightForward"
        },
       yellow3B: {
            moves: {
                defenseLeftBack: [{ coordinates: [{ x: -725, y: -600 }], speed: 1.25 }],
                defenseLeftCenterBack: [{ coordinates: [{ x: -775, y: -175 }], speed: 1.25 }],
                defenseRightCenterBack: [{ coordinates: [{ x: -850, y: 225 }], speed: 1.25 }],
                defenseRightBack: [{ coordinates: [{ x: -925, y: 650 }], speed: 1.25 }],
                defenseLeftMidfield: [{ coordinates: [{ x: -300, y: -700 }], speed: 1.25 }],
                defenseLeftCenterMidfield: [{ coordinates: [{ x: -450, y: -350 }], speed: 1.25 }],
                defenseRightCenterMidfield: [{ coordinates: [{ x: -350, y: 125 }], speed: 1.25 }],
                defenseRightMidfield: [{ coordinates: [{ x: -550, y: 800 }], speed: 1.25 }],
                defenseLeftForward: [{ coordinates: [{ x: 0, y: -25 }], speed: 1.25 }],
                defenseRightForward: [{ coordinates: [{ x: -75, y: 500 }], speed: 1.25 }],
                offenseRightBack: [{ coordinates: [{ x: 175, y: -775 }], speed: 1.25 }],
                offenseRightCenterBack: [{ coordinates: [{ x: 300, y: -250 }], speed: 1.25 }],
                offenseLeftCenterBack: [{ coordinates: [{ x: 275, y: 300 }], speed: 1.25 }],
                offenseLeftBack: [{ coordinates: [{ x: 325, y: 775 }], speed: 1.25 }],
                offenseRightMidfield: [{ coordinates: [{ x: -550, y: -650 }], speed: 1.25 }],
                offenseRightCenterMidfield: [{ coordinates: [{ x: -200, y: -300 }], speed: 1.25 }],
                offenseLeftCenterMidfield: [{ coordinates: [{ x: -350, y: 650 }], speed: 1.25 }],
                offenseLeftMidfield: [{ coordinates: [{ x: -800, y: 600 }], speed: 1.25 }],
                offenseRightForward: [{ coordinates: [{ x: -575, y: -200 }], speed: 1.25 }],
                offenseLeftForward: [{ coordinates: [{ x: -550, y: 300 }], speed: 1.25 }],
                ball: [{ coordinates: [{x: -350, y: 325},{ x: -865, y: 725 }], speed: 1.25 }],
                offenseGoalKeeper: [{ coordinates: [{ x: 950, y: -150 }], speed: 1.25 }],
                defenseGoalKeeper: [{ coordinates: [{ x: -950, y: 100 }], speed: 1.25 }],
                sidelineRef: [{ coordinates: [{ x: -650, y: -1200 }], speed: 1.25 }]
            },
            nextStates: [
                { state: "yellow3Bto4C", trigger: "defenseRightBack" }
            ],
           errorState: "red",
            playerWithBall: "defenseRightBack"
       },
       yellow3Bto4C: {
            moves: {
                defenseLeftBack: [{ coordinates: [{ x: -725, y: -600 }], speed: 1.25 }, { coordinates: [{ x: -675, y: -700 }], speed: 0.75 }],
                defenseLeftCenterBack: [{ coordinates: [{ x: -725, y: -100 }], speed: 0.5 }, { coordinates: [{ x: -675, y: -350 }], speed: 1.5 }],
                defenseRightCenterBack: [{ coordinates: [{ x: -675, y: 475 }, {x:-625,y:500}, { x: -600, y: 425 }, { x: -600, y: 250 }, { x: -700, y: 150 }], speed: 2 }],
                defenseRightBack: [{ coordinates: [{ x: -800, y: 860 }], speed: 0.5 }, { coordinates: [{ x: -650, y: 500 }], speed: 1.5 }],
                defenseLeftMidfield: [{ coordinates: [{ x: -350, y: -700 }], speed: 0.75 }, { coordinates: [{ x: -500, y: -800 }], speed: 0.75 }],
                defenseLeftCenterMidfield: [{ coordinates: [{ x: -275, y: -250 }], speed: 0.5 },{ coordinates: [{ x: -475, y: -200 }], speed: 1.5 }],
                defenseRightCenterMidfield: [{ coordinates: [{ x: -350, y: 200 }], speed: 0.75 },{ coordinates: [{ x: -450, y: 50 }], speed:1.25 }],
                defenseRightMidfield: [{ coordinates: [{ x: -350, y: 800 }], speed: 0.75 },{ coordinates: [{ x: -450, y: 600 }], speed:1.25 }],
                defenseLeftForward: [{ coordinates: [{ x: 50, y: -150 }], speed: 0.5 }, { coordinates: [{ x: -150, y: -25 }], speed:1.5 }],
                defenseRightForward: [{ coordinates: [{ x: 50, y: 700 }], speed: 1.5 }, { coordinates: [{ x: -150, y: 400 }], speed: 0.5 }],
                offenseRightBack: [{ coordinates: [{ x: 75, y: -800 }], speed: 1.5 }],
                offenseRightCenterBack: [{ coordinates: [{ x: 200, y: -300 }], speed: 1.5 }],
                offenseLeftCenterBack: [{ coordinates: [{ x: 200, y: 300 }], speed: 1.5 }],
                offenseLeftBack: [{ coordinates: [{ x: 225, y: 750 }], speed: 1.5 }],
                offenseRightMidfield: [{ coordinates: [{ x: -400, y: -650 }], speed: 0.75 }, { coordinates: [{ x: -550, y: -650 }], speed:1.25 }],
                offenseRightCenterMidfield: [{ coordinates: [{ x: -75, y: -500 }], speed: 0.5 }, { coordinates: [{ x: -400, y: -600 }], speed: 1.5 }],
                offenseLeftCenterMidfield: [{ coordinates: [{ x: -200, y: 550 }], speed: 0.75 }, { coordinates: [{x: -200, y:500}], speed: 0.5}, { coordinates: [{ x: -475, y: 300 }], speed: 0.75 }],
                offenseLeftMidfield: [{ coordinates: [{ x: -775, y: 650 }], speed: 0.75 }, { coordinates: [{ x: -550, y: 600 }], speed:1.25 }],
                offenseRightForward: [{ coordinates: [{ x: -400, y: -150 }], speed: 1 }, { coordinates: [{ x: -575, y: -375 }], speed: 1 }],
                offenseLeftForward: [{ coordinates: [{ x: -600, y: 475 }, {x:-550,y:500}, { x: -450, y: 425 },{x:-455,y:420}, { x: -500, y: 200 }, { x: -675, y: 50 }], speed: 2 }],
                ball: [{ coordinates: [{ x: -755, y: 870 }, { x: -750, y: 875 }, {x:-745,y:870},{x:-255,y:530},{ x: -250, y: 525 }, {x:-255, y:520}, { x: -725, y: 125 }], speed: 1.75}],
                offenseGoalKeeper: [{ coordinates: [{ x: 950, y: -125 }], speed: 1.5 }],
                defenseGoalKeeper: [{ coordinates: [{ x: -950, y: -50 }], speed: 1.5 }],
                sidelineRef: [{ coordinates: [{x: -325, y:-1200}], speed:1},{ coordinates: [{ x: -500, y: -1200 }], speed:1 }]
            },
            nextStates: [
                { state: "goal4C", trigger: "offenseLeftForward" }
            ],
           errorState: "red",
            playerWithBall: "offenseLeftForward"
       },
       yellow3C: {
           moves: {
               defenseLeftBack: [{ coordinates: [{ x: -500, y: -750 }], speed: 1.1 }],
               defenseLeftCenterBack: [{ coordinates: [{ x: -425, y: -250 }], speed: 1.1 }],
               defenseRightCenterBack: [{ coordinates: [{x:-505,y:245},{ x: -500, y: 250 }, { x: -400, y: 450 }], speed: 1 }],
               defenseRightBack: [{ coordinates: [{ x: -300, y: 700 }], speed: 1.1 }],
               defenseLeftMidfield: [{ coordinates: [{ x: -100, y: -700 }, { x: 0, y: -600 }, { x: 100, y: -650 }], speed: 1.1 }],
               defenseLeftCenterMidfield: [{ coordinates: [{ x: -150, y: -250 }, { x: -100, y: -200 }, { x: -50, y: -150 }], speed: 1.1 }],
               defenseRightCenterMidfield: [{ coordinates: [{ x: -300, y: 250 }, { x: -250, y: 200 }, { x: -200, y: 150 }], speed: 1.1 }],
               defenseRightMidfield: [{ coordinates: [{ x: -50, y: 550 }, { x: 100, y: 600 }], speed: 1.1 }],
               defenseLeftForward: [{ coordinates: [{ x: 250, y: -300 }], speed: 1.1 }],
               defenseRightForward: [{ coordinates: [{ x: 250, y: 150 }], speed: 1.1 }],
               offenseRightBack: [{ coordinates: [{ x: 275, y: -800 }], speed: 1.1 }],
               offenseRightCenterBack: [{ coordinates: [{ x: 425, y: -275 }], speed: 1.1 }],
               offenseLeftCenterBack: [{ coordinates: [{ x: 400, y: 250 }], speed: 1.1 }],
               offenseLeftBack: [{ coordinates: [{ x: 375, y: 625 }], speed: 1.1 }],
               offenseRightMidfield: [{ coordinates: [{ x: -350, y: -950 }, { x: -300, y: -850 }], speed: 1.1 }],
               offenseRightCenterMidfield: [{ coordinates: [{ x: 0, y: -150 }, {x:100, y: 150}], speed: 1.1 }],
               offenseLeftCenterMidfield: [{ coordinates: [{ x: -150, y: 350 }, { x: -200, y: 400 }], speed: 1.1 }],
               offenseLeftMidfield: [{ coordinates: [{ x: -250, y: 750 }, { x: -150, y: 700 }], speed: 1.1 }],
               offenseRightForward: [{ coordinates: [{ x: -350, y: -300 }, { x: -250, y: -200 }], speed: 1.1 }],
               offenseLeftForward: [{ coordinates: [{ x: -545, y: 280 }, { x: -550, y: 275 }, {x:-545,y:300}, {x:-500,y:350}], speed: 1.1}],
               ball: [{ coordinates: [{x:-445,y:295}, { x: -450, y: 300 }, {x:-445,y:305},{ x: -350, y: 500 }], speed: .6 }],
               offenseGoalKeeper: [{ coordinates: [{ x: 950, y: 0 }], speed: 1.1 }],
               defenseGoalKeeper: [{ coordinates: [{ x: -950, y: -50 }], speed: 1.1 }],
               sidelineRef: [{ coordinates: [{ x: -300, y: -1200 }], speed: 1.1 }]
           },
           nextStates: [
               { state: "yellow3Cto4E", trigger: "defenseRightCenterBack" }
           ],
           errorState: "red",
           playerWithBall: "defenseRightCenterBack"
       },
       yellow3Cto4E: {
           moves: {
               defenseLeftBack: [{ coordinates: [{x:-350,y:-700}], speed: 0.75},{coordinates: [{ x: -700, y: -650 }], speed:1.25 }],
               defenseLeftCenterBack: [{ coordinates: [{x:-400, y:-225}], speed:1},{coordinates: [{ x: -725, y: -200 }], speed:1 }],
               defenseRightCenterBack: [{ coordinates: [{x:-300,y:400}], speed: 0.75},{coordinates: [{ x: -700, y: 300 }], speed: 1.25 }],
               defenseRightBack: [{ coordinates: [{x:-200,y: 600}],speed: 0.75},{coordinates:[{ x: -600, y: 500 }], speed: 1.25 }],
               defenseLeftMidfield: [{ coordinates: [{x:200, y:-600}], speed:1},{coordinates: [{ x: -450, y: -600 }], speed:1 }],
               defenseLeftCenterMidfield: [{ coordinates: [{x:50,y:0}], speed: 0.75},{ coordinates: [{ x: -350, y: -200 }], speed: 1.25 }],
               defenseRightCenterMidfield: [{coordinates: [{x:-100, y:200}], speed: 1},{ coordinates: [{ x: -450, y: 200 }], speed:1 }],
               defenseRightMidfield: [{ coordinates: [{ x: 150, y: 500 }], speed: 1 },{ coordinates: [{ x: -350, y: 650 }], speed:1 }],
               defenseLeftForward: [{ coordinates: [{x:350,y:-400}], speed: 0.75},{ coordinates: [{ x: -150, y: -100 }],speed:1.25 }],
               defenseRightForward: [{ coordinates: [{x:525,y:100}], speed: 1},{ coordinates: [{ x: -200, y: 200 }], speed:1 }],
               offenseRightBack: [{ coordinates: [{x:325,y:-750}], speed: 0.75},{ coordinates: [{ x: 75, y: -800 }], speed:1.25 }],
               offenseRightCenterBack: [{ coordinates: [{x:475,y:-250}], speed: 0.75},{ coordinates: [{ x: 25, y: -275 }], speed:1.25 }],
               offenseLeftCenterBack: [{ coordinates: [{ x: 100, y: 200 }] }],
               offenseLeftBack: [{ coordinates: [{x:425,y:575}],speed: 0.75},{ coordinates: [{ x: 75, y: 500 }], speed:1.25 }],
               offenseRightMidfield: [{ coordinates: [{x:-100,y:-825}],speed: 0.75},{ coordinates: [{ x: -800, y: -800 }],speed:1.25 }],
               offenseRightCenterMidfield: [{ coordinates: [{x:125,y:0}], speed: 0.75},{ coordinates: [{ x: -300, y: -50 }, { x: -500, y: -150 }], speed:1.25 }],
               offenseLeftCenterMidfield: [{ coordinates: [{x:-250,y:425}], speed: 0.75},{ coordinates: [{ x: -350, y: 450 }, { x: -400, y: 400 }], speed:1.5 }],
               offenseLeftMidfield: [{ coordinates: [{x:175,y:600}],speed: 0.75},{ coordinates: [{ x: -450, y: 800 }],speed:1.25}],
               offenseRightForward: [{ coordinates: [{x:-150,y:-100}], speed: 0.75},{ coordinates: [{ x: -650, y: 100 }],speed:1.25 }],
               offenseLeftForward: [{ coordinates: [{x: -300,y:350}], speed: 0.75},{ coordinates: [{ x: -750, y: 450 }], speed: 1 }],
               ball: [{ coordinates: [{ x: -150, y: 200 }, { x: 0, y: 175 }, { x: 150, y: 200 }, {x:295,y:295},{ x: 300, y: 300 }, {x:295, y:300}, {x:200,y:250}, { x: 100, y: 200 }, { x: -50, y: 175 }, { x: -250, y: 200 }, { x: -400, y: 350 }, { x: -600, y: 500 }, { x: -800, y: 525 }], speed: 2 }],
               offenseGoalKeeper: [{ coordinates: [{ x: 950, y: -75 }] }],
               defenseGoalKeeper: [{ coordinates: [{ x: -950, y: 100 }] }],
               sidelineRef: [{ coordinates: [{x:50, y:-1200}],speed: 1},{ coordinates: [{ x: -650, y: -1200 }],speed: 1 }]
           },
           nextStates: [
                { state: "goal4E", trigger: "offenseLeftForward" }
           ],
           errorState: "red",
           playerWithBall: "offenseLeftForward"
       },
       yellow3D: {
           moves: {
               defenseLeftBack: [{ coordinates: [{ x: -200, y: -700 }],speed: 0.5 }],
               defenseLeftCenterBack: [{ coordinates: [{ x: -525, y: -615 }, { x: -500, y: -450 }], speed: 1 }],
               defenseRightCenterBack: [{ coordinates: [{ x: -420, y: -50 }, { x: -400, y: 0 }], speed: 1 }],
               defenseRightBack: [{ coordinates: [{ x: -400, y: 525 }], speed: 1 }],
               defenseLeftMidfield: [{ coordinates: [{ x: 75, y: -650 }, { x: 250, y: -850 }], speed: 1 }],
               defenseLeftCenterMidfield: [{ coordinates: [{ x: 100, y: -475 }, { x: 150, y: -500 }], speed: 1 }],
               defenseRightCenterMidfield: [{ coordinates: [{ x: -50, y: -50 }], speed: 1 }],
               defenseRightMidfield: [{ coordinates: [{ x: 0, y: 500 }, { x: 250, y: 650 }], speed: 1 }],
               defenseLeftForward: [{ coordinates: [{x:300,y:-300},{ x: 350, y: -400 }], speed: 1 }],
               defenseRightForward: [{ coordinates: [{x:250,y:250}, { x: 300, y: 200 }], speed:1 }],
               offenseRightBack: [{ coordinates: [{ x: 425, y: -800 }], speed: 1 }],
               offenseRightCenterBack: [{ coordinates: [{ x: 425, y: -275 }], speed: 1 }],
               offenseLeftCenterBack: [{ coordinates: [{ x: 400, y: 125 }], speed: 1 }],
               offenseLeftBack: [{ coordinates: [{ x: 375, y: 475 }], speed: 1 }],
               offenseRightMidfield: [{ coordinates: [{ x: -150, y: -1050 }], speed: 1.5 }],
               offenseRightCenterMidfield: [{ coordinates: [{ x: 75, y: -75 }], speed: 1 }],
               offenseLeftCenterMidfield: [{ coordinates: [{ x: -150, y: 200 }, { x: -100, y: 300 }], speed: 1 }],
               offenseLeftMidfield: [{ coordinates: [{ x: -200, y: 700 }, { x: -150, y: 650 }], speed: 1 }],
               offenseRightForward: [{ coordinates: [{ x: -500, y: -850 }, { x: -475, y: -875 }], speed: 1 }],
               offenseLeftForward: [{ coordinates: [{ x: -400, y: -300 }, { x: -350, y: -325 }], speed: 1 }],
               ball: [{ coordinates: [{ x: -150, y: -630 }, { x: -150, y: -625 }, {x:-145,y:-620},{ x: 0, y: 0 }], speed: .8 }],
               offenseGoalKeeper: [{ coordinates: [{ x: 950, y: -150 }], speed: 1 }],
               defenseGoalKeeper: [{ coordinates: [{ x: -950, y: -150 }], speed: 1 }],
               sidelineRef: [{ coordinates: [{ x: 0, y: -1200 }], speed: 1 }]
           },
           nextStates: [
               { state: "yellow3Dto4G", trigger: "defenseRightCenterMidField" }
           ],
           errorState: "red",
           playerWithBall: "defenseRightCenterMidField"
       },
       yellow3Dto4G: {
           moves: {
               defenseLeftBack: [{ coordinates: [{ x: -650, y: -775 }] }],
               defenseLeftCenterBack: [{ coordinates: [{ x: -750, y: -550 }] }],
               defenseRightCenterBack: [{ coordinates: [{ x: -725, y: -150 }] }],
               defenseRightBack: [{ coordinates: [{ x: -650, y: 400 }] }],
               defenseLeftMidfield: [{ coordinates: [{ x: -300, y: -750 }] }],
               defenseLeftCenterMidfield: [{ coordinates: [{ x: -350, y: -450 }] }],
               defenseRightCenterMidfield: [{ coordinates: [{ x: -425, y: 0 }] }],
               defenseRightMidfield: [{ coordinates: [{ x: -350, y: 450 }] }],
               defenseLeftForward: [{ coordinates: [{ x: 50, y: -300 }] }],
               defenseRightForward: [{ coordinates: [{ x: 0, y: 200 }] }],
               offenseRightBack: [{ coordinates: [{ x: 275, y: -700 }] }],
               offenseRightCenterBack: [{ coordinates: [{ x: 325, y: -300 }] }],
               offenseLeftCenterBack: [{ coordinates: [{ x: 300, y: 100 }] }],
               offenseLeftBack: [{ coordinates: [{ x: 175, y: 400 }] }],
               offenseRightMidfield: [{ coordinates: [{ x: -150, y: -750 }], speed: 0.75 }, { coordinates: [{ x: -450, y: -950 }], speed: 1.25 }],
               offenseRightCenterMidfield: [{ coordinates: [{x:75,y:-125},{ x: -250, y: -250 }] }],
               offenseLeftCenterMidfield: [{ coordinates: [{ x: -550, y: 150 }] }],
               offenseLeftMidfield: [{ coordinates: [{ x: -450, y: 650 }] }],
               offenseRightForward: [{ coordinates: [{ x: -650, y: -650 }] }],
               offenseLeftForward: [{ coordinates: [{ x: -575, y: -400 }], speed: 1.5 }],
               ball: [{ coordinates: [{ x: 25, y: -50 }, {x:-200,y:-645},{ x: -200, y: -650 },{x:-205,y:-650}, {x:-245,y:-650}, { x: -250, y: -650 }, {x:-255,y:-650}, { x: -625, y: -325 }], speed: 1.75 }],
               offenseGoalKeeper: [{ coordinates: [{ x: 950, y: -175 }] }],
               defenseGoalKeeper: [{ coordinates: [{ x: -950, y: -250 }] }],
               sidelineRef: [{ coordinates: [{ x: -450, y: -1200 }] }]
           },
           nextStates: [
               { state: "goal4G", trigger: "offenseLeftForward" }
           ],
           errorState: "red",
           playerWithBall: "offenseLeftForward"
       },
       yellow4A: {
           moves: {
               defenseLeftBack: [{ coordinates: [{ x: -800, y: -575 }], speed: 1.25 }],
               defenseLeftCenterBack: [{ coordinates: [{ x: -800, y: -300 }], speed: 1.25 }],
               defenseRightCenterBack: [{ coordinates: [{ x: -725, y: 450 }], speed: 1.25 }],
               defenseRightBack: [{ coordinates: [{ x: -850, y: 675 }], speed: 1.25 }],
               defenseLeftMidfield: [{ coordinates: [{ x: -450, y: -650 }], speed: 1.25 }],
               defenseLeftCenterMidfield: [{ coordinates: [{ x: -425, y: -250 }], speed: 1.25 }],
               defenseRightCenterMidfield: [{ coordinates: [{ x: -450, y: 225 }], speed: 1.25 }],
               defenseRightMidfield: [{ coordinates: [{ x: -400, y: 650 }], speed: 1.25 }],
               defenseLeftForward: [{ coordinates: [{ x: 0, y: -100 }], speed: 1.25 }],
               defenseRightForward: [{ coordinates: [{ x: 0, y: 700 }], speed: 1.25 }],
               offenseRightBack: [{ coordinates: [{ x: 25, y: -750 }], speed: 1.25 }],
               offenseRightCenterBack: [{ coordinates: [{ x: 150, y: -200 }], speed: 1.25 }],
               offenseLeftCenterBack: [{ coordinates: [{ x: 350, y: 400 }], speed: 1.25 }],
               offenseLeftBack: [{ coordinates: [{ x: 275, y: 800 }], speed: 1.25 }],
               offenseRightMidfield: [{ coordinates: [{ x: -650, y: -700 }], speed: 1.25 }],
               offenseRightCenterMidfield: [{ coordinates: [{ x: -650, y: 125 }], speed: 1.25 }],
               offenseLeftCenterMidfield: [{ coordinates: [{ x: -900, y: 750 }], speed: 1.25 }],
               offenseLeftMidfield: [{ coordinates: [{ x: -300, y: 350 }], speed: 1.25 }],
               offenseRightForward: [{ coordinates: [{ x: -700, y: -350 }], speed: 1.25 }],
               offenseLeftForward: [{ coordinates: [{ x: -650, y: 575 }], speed: 1.25 }],
               ball: [{ coordinates: [{ x: -935, y: 825 }, { x: -1000, y: 350 }, { x: -900, y: -150 }, {x:-755,y:-300}, { x: -750, y: -300 }, {x:-745,y:-295},{ x: -700, y: 175 }], speed: 1.5 }],
               offenseGoalKeeper: [{ coordinates: [{ x: 950, y: -50 }], speed: 1.25 }],
               defenseGoalKeeper: [{ coordinates: [{ x: -950, y: -100 }], speed: 1.25 }],
               sidelineRef: [{ coordinates: [{ x: -750, y: -1200 }], speed: 1.25 }]
           },
           nextStates: [
               { state: "goalYellow4A", trigger: "offenseRightCenterMidfield" }
           ],
           errorState: "red",
           playerWithBall: "offenseRightCenterMidfield"
       },
       goalYellow4A: {
           moves: {
               defenseLeftBack: [{ coordinates: [{ x: -775, y: -550 }], speed: 0.25 }],
               defenseLeftCenterBack: [{ coordinates: [{ x: -775, y: -275 }], speed: 0.25 }],
               defenseRightCenterBack: [{ coordinates: [{ x: -750, y: 425 }], speed: 0.25 }],
               defenseRightBack: [{ coordinates: [{ x: -825, y: 650 }], speed: 0.25 }],
               defenseLeftMidfield: [{ coordinates: [{ x: -475, y: -625 }], speed: 0.25 }],
               defenseLeftCenterMidfield: [{ coordinates: [{ x: -450, y: -275 }], speed: 0.25 }],
               defenseRightCenterMidfield: [{ coordinates: [{ x: -475, y: 200 }], speed: 0.25 }],
               defenseRightMidfield: [{ coordinates: [{ x: -425, y: 625 }], speed: 0.25 }],
               defenseLeftForward: [{ coordinates: [{ x: -25, y: -50 }], speed: 0.25 }],
               defenseRightForward: [{ coordinates: [{ x: -25, y: 675 }], speed: 0.25 }],
               offenseRightBack: [{ coordinates: [{ x: 0, y: -725 }], speed: 0.25 }],
               offenseRightCenterBack: [{ coordinates: [{ x: 125, y: -175 }], speed: 0.25 }],
               offenseLeftCenterBack: [{ coordinates: [{ x: 325, y: 375 }], speed: 0.25 }],
               offenseLeftBack: [{ coordinates: [{ x: 250, y: 775 }], speed: 0.25 }],
               offenseRightMidfield: [{ coordinates: [{ x: -675, y: -675 }], speed: 0.25 }],
               offenseRightCenterMidfield: [{ coordinates: [{ x: -675, y: 125 }], speed: 0.25 }],
               offenseLeftCenterMidfield: [{ coordinates: [{ x: -900, y: 725 }], speed: 0.25 }],
               offenseLeftMidfield: [{ coordinates: [{ x: -325, y: 325 }], speed: 0.25 }],
               offenseRightForward: [{ coordinates: [{ x: -725, y: -325 }], speed: 0.25 }],
               offenseLeftForward: [{ coordinates: [{ x: -675, y: 550 }], speed: 0.25 }],
               ball: [{ coordinates: [{ x: -1000, y: -75 }], speed: 0.25 }],
               offenseGoalKeeper: [{ coordinates: [{ x: 950, y: -150 }], speed: 0.25 }],
               defenseGoalKeeper: [{ coordinates: [{ x: -950, y: -150 }], speed: 0.25 }],
               sidelineRef: [{ coordinates: [{ x: -750, y: -1200 }], speed: 0.25 }]
           },
           nextStates: [
               { state: "zoomInOnGoal_DiveLeft" }
           ],
           advanceOnCompletion: true,
           playerWithBall: "offenseRightCenterMidfield"
       },
       yellow4B: {
           moves: {
               defenseLeftBack: [{ coordinates: [{ x: -750, y: -650 }], speed: 1.25 }],
               defenseLeftCenterBack: [{ coordinates: [{ x: -800, y: -150 }], speed: 1.25 }],
               defenseRightCenterBack: [{ coordinates: [{ x: -750, y: 275 }], speed: 1.25 }],
               defenseRightBack: [{ coordinates: [{ x: -750, y: 600 }], speed: 1.25 }],
               defenseLeftMidfield: [{ coordinates: [{ x: -350, y: -550 }], speed: 1.25 }],
               defenseLeftCenterMidfield: [{ coordinates: [{ x: -425, y: -100 }], speed: 1.25 }],
               defenseRightCenterMidfield: [{ coordinates: [{ x: -500, y: 275 }], speed: 1.25 }],
               defenseRightMidfield: [{ coordinates: [{ x: -550, y: 800 }], speed: 1.25 }],
               defenseLeftForward: [{ coordinates: [{ x: 0, y: -75 }], speed: 1.25 }],
               defenseRightForward: [{ coordinates: [{ x: -25, y: 450 }], speed: 1.25 }],
               offenseRightBack: [{ coordinates: [{ x: 100, y: -750 }], speed: 1.25 }],
               offenseRightCenterBack: [{ coordinates: [{ x: 150, y: -325 }], speed: 1.25 }],
               offenseLeftCenterBack: [{ coordinates: [{ x: 250, y: 350 }], speed: 1.25 }],
               offenseLeftBack: [{ coordinates: [{ x: 125, y: 800 }], speed: 1.25 }],
               offenseRightMidfield: [{ coordinates: [{ x: -550, y: -650 }], speed: 1.25 }],
               offenseRightCenterMidfield: [{ coordinates: [{ x: -650, y: 0 }], speed: 1.25 }],
               offenseLeftCenterMidfield: [{ coordinates: [{ x: -600, y: 500 }], speed: 1.25 }],
               offenseLeftMidfield: [{ coordinates: [{ x: -400, y: 450 }], speed: 1.25 }],
               offenseRightForward: [{ coordinates: [{ x: -750, y: -450 }], speed: 1.25 }],
               offenseLeftForward: [{ coordinates: [{ x: -800, y: 725 }], speed: 1.25 }],
               ball: [{ coordinates: [{x:-950,y:-100},{ x: -1000, y: -100 },{x:-975, y:-100},{ x: -825, y: 100 }, { x: -800, y: 400 }, { x: -825, y: 600 }, { x: -850, y: 700 }, { x: -850, y: 775 }], speed: 1.2 }],
               offenseGoalKeeper: [{ coordinates: [{ x: 950, y: 50 }], speed: 1.25 }],
               defenseGoalKeeper: [{ coordinates: [{ x: -950, y: 75 }, { x: -1000, y: -125 }, { x: -950, y: 100 }], speed: 1 }],
               sidelineRef: [{ coordinates: [{ x: -750, y: -1200 }], speed: 1.25 }]
           },
           nextStates: [
               { state: "goalYellow4B", trigger: "offenseLeftForward" }
           ],
           errorState: "red",
           playerWithBall: "offenseLeftForward"
       },
       goalYellow4B: {
           moves: {
               defenseLeftBack: [{ coordinates: [{ x: -800, y: -625 }], speed: 0.75 }],
               defenseLeftCenterBack: [{ coordinates: [{ x: -875, y: -50 }], speed: 0.75 }],
               defenseRightCenterBack: [{ coordinates: [{ x: -800, y: 175 }], speed: 0.75 }],
               defenseRightBack: [{ coordinates: [{ x: -850, y: 500 }], speed: 0.75 }],
               defenseLeftMidfield: [{ coordinates: [{ x: -450, y: -500 }], speed: 0.75 }],
               defenseLeftCenterMidfield: [{ coordinates: [{ x: -625, y: -50 }], speed: 0.75 }],
               defenseRightCenterMidfield: [{ coordinates: [{ x: -550, y: 175 }], speed: 0.75 }],
               defenseRightMidfield: [{ coordinates: [{ x: -750, y: 600 }], speed: 0.75 }],
               defenseLeftForward: [{ coordinates: [{ x: -75, y: -50 }], speed: 0.75 }],
               defenseRightForward: [{ coordinates: [{ x: -125, y: 350 }], speed: 0.75 }],
               offenseRightBack: [{ coordinates: [{ x: 50, y: -650 }], speed: 0.75 }],
               offenseRightCenterBack: [{ coordinates: [{ x: 50, y: -225 }], speed: 0.75 }],
               offenseLeftCenterBack: [{ coordinates: [{ x: 150, y: 250 }], speed: 0.75 }],
               offenseLeftBack: [{ coordinates: [{ x: 25, y: 700 }], speed: 0.75 }],
               offenseRightMidfield: [{ coordinates: [{ x: -600, y: -600 }], speed: 0.75 }],
               offenseRightCenterMidfield: [{ coordinates: [{ x: -700, y: 0 }], speed: 0.75 }],
               offenseLeftCenterMidfield: [{ coordinates: [{ x: -625, y: 400 }], speed: 0.75 }],
               offenseLeftMidfield: [{ coordinates: [{ x: -450, y: 400 }], speed: 0.75 }],
               offenseRightForward: [{ coordinates: [{ x: -800, y: -400 }], speed: 0.75 }],
               offenseLeftForward: [{ coordinates: [{ x: -825, y: 375 }], speed: 0.75 }],
               ball: [{ coordinates: [{ x: -875, y: 575 }, { x: -900, y: 375 }, { x: -875, y: 175 }, {x:-705,y:75}, { x: -700, y: 75 }, {x:-705,y:70},{ x: -1000, y: -300 }], speed: 0.75 }],
               offenseGoalKeeper: [{ coordinates: [{ x: 950, y: -150 }], speed: 0.75 }],
               defenseGoalKeeper: [{ coordinates: [{ x: -950, y: -200 }], speed: 0.75 }],
               sidelineRef: [{ coordinates: [{ x: -750, y: -1200 }], speed: 0.75 }]
           },
           nextStates: [
               { state: "zoomInOnGoal_DiveLeft" }
           ],
           advanceOnCompletion: true,
           playerWithBall: "offenseRightCenterMidfield"
       },
       yellow4C: {
           moves: {
               defenseLeftBack: [{ coordinates: [{ x: -750, y: -675 }], speed: 1.2 }],
               defenseLeftCenterBack: [{ coordinates: [{ x: -700, y: -350 }], speed: 1.2 }],
               defenseRightCenterBack: [{ coordinates: [{ x: -700, y: 75 }], speed: 1.2 }],
               defenseRightBack: [{ coordinates: [{ x: -675, y: 475 }], speed: 1.2 }],
               defenseLeftMidfield: [{ coordinates: [{ x: -525, y: -800 }], speed: 1.2 }],
               defenseLeftCenterMidfield: [{ coordinates: [{ x: -500, y: -200 }], speed: 1.2 }],
               defenseRightCenterMidfield: [{ coordinates: [{ x: -475, y: 150 }], speed: 1.2 }],
               defenseRightMidfield: [{ coordinates: [{ x: -475, y: 575 }], speed: 1.2 }],
               defenseLeftForward: [{ coordinates: [{ x: -175, y: -50 }], speed: 1.2 }],
               defenseRightForward: [{ coordinates: [{ x: -175, y: 375 }], speed: 1.2 }],
               offenseRightBack: [{ coordinates: [{ x: 50, y: -800 }], speed: 1.2 }],
               offenseRightCenterBack: [{ coordinates: [{ x: 150, y: -300 }], speed: 1.2 }],
               offenseLeftCenterBack: [{ coordinates: [{ x: 150, y: 300 }], speed: 1.2 }],
               offenseLeftBack: [{ coordinates: [{ x: 175, y: 750 }], speed: 1.2 }],
               offenseRightMidfield: [{ coordinates: [{ x: -575, y: -600 }], speed: 1.2 }],
               offenseRightCenterMidfield: [{ coordinates: [{ x: -425, y: -575 }], speed: 1.2 }],
               offenseLeftCenterMidfield: [{ coordinates: [{ x: -600, y: 275 }], speed: 1.2 }],
               offenseLeftMidfield: [{ coordinates: [{ x: -575, y: 575 }], speed: 1.2 }],
               offenseRightForward: [{ coordinates: [{ x: -600, y: -350 }], speed: 1.2 }],
               offenseLeftForward: [{ coordinates: [{ x: -725, y: -100 }], speed: 1.2 }],
               ball: [{ coordinates: [{ x: -950, y: -75 }, { x: -1000, y: -75 }, {x:-950,y:-75},{ x: -850, y: -50 }, { x: -775, y: 100 }, { x: -650, y: 325 }], speed: .8 }],
               offenseGoalKeeper: [{ coordinates: [{ x: 950, y: 50 }], speed: 1.2 }],
               defenseGoalKeeper: [{ coordinates: [{ x: -950, y: 0 }, { x: -1000, y: -25 }, { x: -950, y: 50 }], speed: .8 }],
               sidelineRef: [{ coordinates: [{ x: -700, y: -1200 }], speed: 1.2 }]
           },
           nextStates: [
               { state: "goalYellow4C", trigger: "offenseLeftCenterMidfield" }
           ],
           errorState: "red",
           playerWithBall: "offenseLeftCenterMidfield"
       },
       goalYellow4C: {
           moves: {
               defenseLeftBack: [{ coordinates: [{ x: -775, y: -675 }], speed: 0.5 }],
               defenseLeftCenterBack: [{ coordinates: [{ x: -725, y: -350 }], speed: 0.5 }],
               defenseRightCenterBack: [{ coordinates: [{ x: -725, y: 75 }], speed: 0.5 }],
               defenseRightBack: [{ coordinates: [{ x: -700, y: 475 }], speed: 0.5 }],
               defenseLeftMidfield: [{ coordinates: [{ x: -550, y: -800 }], speed: 0.5 }],
               defenseLeftCenterMidfield: [{ coordinates: [{ x: -525, y: -200 }], speed: 0.5 }],
               defenseRightCenterMidfield: [{ coordinates: [{ x: -500, y: 150 }], speed: 0.5 }],
               defenseRightMidfield: [{ coordinates: [{ x: -500, y: 575 }], speed: 0.5 }],
               defenseLeftForward: [{ coordinates: [{ x: -200, y: -50 }], speed: 0.5 }],
               defenseRightForward: [{ coordinates: [{ x: -200, y: 375 }], speed: 0.5 }],
               offenseRightBack: [{ coordinates: [{ x: 0, y: -800 }], speed: 0.5 }],
               offenseRightCenterBack: [{ coordinates: [{ x: 100, y: -300 }], speed: 0.5 }],
               offenseLeftCenterBack: [{ coordinates: [{ x: 100, y: 300 }], speed: 0.5 }],
               offenseLeftBack: [{ coordinates: [{ x: 150, y: 750 }], speed: 0.5 }],
               offenseRightMidfield: [{ coordinates: [{ x: -600, y: -600 }], speed: 0.5 }],
               offenseRightCenterMidfield: [{ coordinates: [{ x: -450, y: -575 }], speed: 0.5 }],
               offenseLeftCenterMidfield: [{ coordinates: [{ x: -625, y: 275 }], speed: 0.5 }],
               offenseLeftMidfield: [{ coordinates: [{ x: -600, y: 575 }], speed: 0.5 }],
               offenseRightForward: [{ coordinates: [{ x: -625, y: -350 }], speed: 0.5 }],
               offenseLeftForward: [{ coordinates: [{ x: -750, y: -100 }], speed: 0.5 }],
               ball: [{ coordinates: [{ x: -1030, y: -575 }], speed: 0.5 }],
               offenseGoalKeeper: [{ coordinates: [{ x: 950, y: 50 }], speed: 0.5 }],
               defenseGoalKeeper: [{ coordinates: [{ x: -950, y: -250 }], speed: 0.5 }],
               sidelineRef: [{ coordinates: [{ x: -750, y: -1200 }], speed: 0.5 }]
           },
           nextStates: [
               { state: "zoomInOnGoal_DiveRight" }
           ],
           advanceOnCompletion: true,
           playerWithBall: "offenseLeftCenterMidfield"
       },
       yellow4D: {
           moves: {
               defenseLeftBack: [{ coordinates: [{ x: -825, y: -500 }], speed: 0.5 }, { coordinates: [{x:-775,y:-450}], speed: 0.5}],
               defenseLeftCenterBack: [{ coordinates: [{ x: -825, y: -50 }], speed: 0.5 }, { coordinates: [{x:-775,y:0}], speed: 0.5}],
               defenseRightCenterBack: [{ coordinates: [{ x: -725, y: 225 }], speed: 0.5 }, { coordinates: [{x:-700,y:300}], speed: 0.5}],
               defenseRightBack: [{ coordinates: [{ x: -725, y: 500 }],speed: 0.5 }, {coordinates:[{x:-625, y:550}], speed: 0.5}],
               defenseLeftMidfield: [{ coordinates: [{ x: -400, y: -675 }], speed: 1 }],
               defenseLeftCenterMidfield: [{ coordinates: [{ x: -550, y: -200 }], speed: 1 }],
               defenseRightCenterMidfield: [{ coordinates: [{ x: -475, y: 150 }], speed: 1 }],
               defenseRightMidfield: [{ coordinates: [{ x: -450, y: 550 }], speed: 1 }],
               defenseLeftForward: [{ coordinates: [{ x: -250, y: -75 }], speed: 1 }],
               defenseRightForward: [{ coordinates: [{ x: -250, y: 450 }], speed: 1 }],
               offenseRightBack: [{ coordinates: [{ x: 0, y: -775 }], speed: 1 }],
               offenseRightCenterBack: [{ coordinates: [{ x: 50, y: -275 }], speed: 1 }],
               offenseLeftCenterBack: [{ coordinates: [{ x: 150, y: 325 }], speed: 1 }],
               offenseLeftBack: [{ coordinates: [{ x: 150, y: 700 }], speed: 1 }],
               offenseRightMidfield: [{ coordinates: [{ x: -750, y: -650 }], speed: 1 }],
               offenseRightCenterMidfield: [{ coordinates: [{ x: -600, y: -500 }], speed: 1 }],
               offenseLeftCenterMidfield: [{ coordinates: [{ x: -475, y: 275 }], speed: 1 }],
               offenseLeftMidfield: [{ coordinates: [{ x: -650, y: 500 }, { x: -525, y: 525 }, { x: -450, y: 725 }], speed: 1 }],
               offenseRightForward: [{ coordinates: [{ x: -700, y: 125 }], speed: 1 }],
               offenseLeftForward: [{ coordinates: [{ x: -650, y: 350 }, { x: -660, y: 360 }], speed: 1 }],
               ball: [{ coordinates: [{x:-950,y:-75}, { x: -1000, y: -75 }, {x:-950,y:-75},{ x: -900, y: -100 }, { x: -800, y: -25 }, { x: -700, y: 100 }, { x: -575, y: 400 }, { x: -500, y: 775 }], speed: 1 }],
               offenseGoalKeeper: [{ coordinates: [{ x: 950, y: 50 }], speed: 1 }],
               defenseGoalKeeper: [{ coordinates: [{ x: -950, y: 50 }, { x: -995, y: -50 }, { x: -950, y: 100 }], speed: 0.7 }],
               sidelineRef: [{ coordinates: [{ x: -600, y: -1200 }], speed: 1 }]
           },
           nextStates: [
               { state: "goalYellow4D", trigger: "offenseLeftMidfield" }
           ],
           errorState: "red",
           playerWithBall: "offenseLeftMidfield"
       },
       goalYellow4D: {
           moves: {
               defenseLeftBack: [ { coordinates: [{ x: -750, y: -450 }], speed: 1 }],
               defenseLeftCenterBack: [{ coordinates: [{ x: -750, y: -50 }], speed: 1 }],
               defenseRightCenterBack: [{ coordinates: [{ x: -675, y: 250 }], speed: 1 }],
               defenseRightBack: [{ coordinates: [{ x: -600, y: 525 }], speed: 1 }],
               defenseLeftMidfield: [{ coordinates: [{ x: -500, y: -600 }], speed:1 }],
               defenseLeftCenterMidfield: [{ coordinates: [{ x: -600, y: -150 }], speed:1 }],
               defenseRightCenterMidfield: [{ coordinates: [{ x: -500, y: 150 }], speed:1 }],
               defenseRightMidfield: [{ coordinates: [{ x: -500, y: 575 }], speed:1 }],
               defenseLeftForward: [{ coordinates: [{ x: -275, y: -75 }], speed:1 }],
               defenseRightForward: [{ coordinates: [{ x: -275, y: 500 }], speed:1 }],
               offenseRightBack: [{ coordinates: [{ x: -50, y: -750 }], speed: 1 }],
               offenseRightCenterBack: [{ coordinates: [{ x: 0, y: -225 }], speed: 1 }],
               offenseLeftCenterBack: [{ coordinates: [{ x: 50, y: 355 }], speed: 1 }],
               offenseLeftBack: [{ coordinates: [{ x: 50, y: 750 }], speed: 1 }],
               offenseRightMidfield: [{ coordinates: [{ x: -800, y: -650 }], speed:1 }],
               offenseRightCenterMidfield: [{ coordinates: [{ x: -700, y: -350 }], speed: 0.75 }],
               offenseLeftCenterMidfield: [{ coordinates: [{ x: -500, y: 300 }], speed:1 }],
               offenseLeftMidfield: [{ coordinates: [{ x: -500, y: 700 }], speed: 1 }],
               offenseRightForward: [{ coordinates: [{ x: -725, y: 125 }], speed: 1 }],
               offenseLeftForward: [{ coordinates: [{ x: -675, y: 360 }], speed:1 }],
               ball: [{ coordinates: [{x:-735,y:-245}, { x: -735, y: -250 }, {x:-740,y:-250},{ x: -1000, y: -400 }], speed: 0.85 }],
               offenseGoalKeeper: [{ coordinates: [{ x: 950, y: -150 }],speed: 1 }],
               defenseGoalKeeper: [{ coordinates: [{ x: -950, y: -200 }], speed: 1 }],
               sidelineRef: [{ coordinates: [{ x: -750, y: -1200 }], speed: 1 }]
           },
           nextStates: [
               { state: "zoomInOnGoal_DiveRight" }
           ],
           advanceOnCompletion: true,
           playerWithBall: "offenseLeftMidfield"
       },
       yellow4E: {
           moves: {
               defenseLeftBack: [{ coordinates: [{ x: -750, y: -625 }], speed: 0.5 }, { coordinates: [{x:-775,y:-700}], speed: 0.5}],
               defenseLeftCenterBack: [{ coordinates: [{x:-750,y:-250},{ x: -775, y: -350 }], speed:1 }],
               defenseRightCenterBack: [{ coordinates: [{ x: -750, y: 200 }], speed:1 }],
               defenseRightBack: [{ coordinates: [{ x: -625, y: 475 }, {x:-625,y:450}], speed:1 }],
               defenseLeftMidfield: [{ coordinates: [{ x: -500, y: -600 }, {x:-550,y:-625}], speed:1 }],
               defenseLeftCenterMidfield: [{ coordinates: [{ x: -400, y: -250 }],speed:1 }],
               defenseRightCenterMidfield: [{ coordinates: [{ x: -450, y: 150 }],speed:1 }],
               defenseRightMidfield: [{ coordinates: [{ x: -550, y: 600 }], speed:1 }],
               defenseLeftForward: [{ coordinates: [{ x: -200, y: -125 }], speed:1 }],
               defenseRightForward: [{ coordinates: [{ x: -225, y: 300 }], speed:1 }],
               offenseRightBack: [{ coordinates: [{ x: -75, y: -800 }], speed: 1 }],
               offenseRightCenterBack: [{ coordinates: [{ x: -25, y: -375 }], speed: 1 }],
               offenseLeftCenterBack: [{ coordinates: [{ x: 0, y: 100 }], speed: 1 }],
               offenseLeftBack: [{ coordinates: [{ x: -75, y: 400 }], speed: 1 }],
               offenseRightMidfield: [{ coordinates: [{x:-850, y:-750}], speed: 0.5},{ coordinates: [{ x: -840, y: -1000 }], speed: 0.5 }],
               offenseRightCenterMidfield: [{ coordinates: [{ x: -525, y: -125 }, {x:-575,y:-325}], speed:1 }],
               offenseLeftCenterMidfield: [{ coordinates: [{ x: -425, y: 400 }, {x:-500,y:300}], speed:1 }],
               offenseLeftMidfield: [{ coordinates: [{ x: -650, y: 700 }], speed:1 }],
               offenseRightForward: [{ coordinates: [{ x: -675, y: 75 }], speed: 0.5 }, { coordinates: [{x:-600,y:-50}], speed: 0.5} ],
               offenseLeftForward: [{ coordinates: [{ x: -775, y: 425 }], speed: 1 }],
               ball: [{ coordinates: [{ x: -940, y: -120 }, { x: -950, y: -125 }, {x:-940, y:-130},{x:-900,y:-150},{ x: -850, y: -600 }, { x: -875, y: -800 }, { x: -900, y: -875 }], speed: 0.85 }],
               offenseGoalKeeper: [{ coordinates: [{ x: 950, y: 50 }], speed: 1 }],
               defenseGoalKeeper: [{ coordinates: [{ x: -950, y: 40 }, { x: -960, y: -50 }, { x: -950, y: -25 }, { x: -950, y: -250 }], speed: 0.75 }],
               sidelineRef: [{ coordinates: [{ x: -750, y: -1200 }], speed: 1 }]
           },
           nextStates: [
               { state: "goalYellow4E", trigger: "offenseRightMidfield" }
           ],
           errorState: "red",
           playerWithBall: "offenseRightMidfield"
       },
       goalYellow4E: {
           moves: {
               defenseLeftBack: [{ coordinates: [{ x: -800, y: -725 }, {x:-825, y:-675}], speed: 1 }],
               defenseLeftCenterBack: [{ coordinates: [{ x: -800, y: -375 }, {x:-800, y:-300}], speed: 1 }],
               defenseRightCenterBack: [{ coordinates: [{ x: -725, y: 175 }], speed: 1 }],
               defenseRightBack: [{ coordinates: [{ x: -675, y: 400 }], speed: 1 }],
               defenseLeftMidfield: [{coordinates: [{ x: -575, y: -600 }], speed: 1 }],
               defenseLeftCenterMidfield: [{ coordinates: [{ x: -600, y: -100 }], speed: 1 }],
               defenseRightCenterMidfield: [{ coordinates: [{ x: -500, y: 100 }], speed: 1 }],
               defenseRightMidfield: [{ coordinates: [{ x: -575, y: 500 }], speed: 1 }],
               defenseLeftForward: [{ coordinates: [{ x: -300, y: -150 }], speed: 1 }],
               defenseRightForward: [{ coordinates: [{ x: -325, y: 250 }], speed: 1 }],
               offenseRightBack: [{ coordinates: [{ x: -75, y: -750 }], speed: 1 }],
               offenseRightCenterBack: [{ coordinates: [{ x: -50, y: -350 }], speed: 1 }],
               offenseLeftCenterBack: [{ coordinates: [{ x: -25, y: 125 }], speed: 1 }],
               offenseLeftBack: [{ coordinates: [{ x: -100, y: 425 }], speed: 1 }],
               offenseRightMidfield: [{ coordinates: [{ x: -840, y: -1000 }], speed: 0.75 }],
               offenseRightCenterMidfield: [{ coordinates: [{ x: -600, y: -350 }], speed: 1 }],
               offenseLeftCenterMidfield: [{ coordinates: [{ x: -600, y: 200 }], speed: 1 }],
               offenseLeftMidfield: [{ coordinates: [{ x: -675, y: 675 }], speed: 1 }],
               offenseRightForward: [{ coordinates: [{ x: -700, y: -50 }], speed: 0.75 }],
               offenseLeftForward: [{ coordinates: [{ x: -800, y: 400 }], speed: 1 }],
               ball: [{ coordinates: [{ x: -900, y: -875 }, { x: -755, y: 45 }, { x: -750, y: 50 }, {x:-755,y:50},{ x: -1000, y: -125 }], speed: 0.9 }],
               offenseGoalKeeper: [{ coordinates: [{ x: 950, y: -200 }], speed: 1 }],
               defenseGoalKeeper: [{ coordinates: [{ x: -950, y: -150 }], speed: 1 }],
               sidelineRef: [{ coordinates: [{ x: -750, y: -1200 }], speed: 1 }]
           },
           nextStates: [
               { state: "zoomInOnGoal_DiveLeft" }
           ],
           advanceOnCompletion: true,
           playerWithBall: "offenseRightForward"
       },
       yellow4F: {
           moves: {
               defenseLeftBack: [{ coordinates: [{ x: -850, y: -650 }], speed: 0.75 }],
               defenseLeftCenterBack: [{ coordinates: [{ x: -800, y: -250 }], speed: 0.75 }],
               defenseRightCenterBack: [{ coordinates: [{ x: -800, y: 150 }], speed: 0.75 }],
               defenseRightBack: [{ coordinates: [{ x: -750, y: 500 }], speed: 0.75 }],
               defenseLeftMidfield: [{ coordinates: [{ x: -550, y: -550 }], speed:1.25 }],
               defenseLeftCenterMidfield: [{ coordinates: [{ x: -600, y: -175 }], speed: 1.25 }],
               defenseRightCenterMidfield: [{ coordinates: [{ x: -550, y: 125 }], speed: 1.25 }],
               defenseRightMidfield: [{ coordinates: [{ x: -450, y: 550 }], speed: 1.25 }],
               defenseLeftForward: [{ coordinates: [{ x: -150, y: -275 }], speed:1 }],
               defenseRightForward: [{ coordinates: [{ x: -75, y: 350 }], speed:1 }],
               offenseRightBack: [{ coordinates: [{ x: -75, y: -700 }], speed: 1.25 }],
               offenseRightCenterBack: [{ coordinates: [{ x: 25, y: -275 }], speed: 1.25 }],
               offenseLeftCenterBack: [{ coordinates: [{ x: 100, y: 125 }], speed: 1.25 }],
               offenseLeftBack: [{ coordinates: [{ x: 25, y: 375 }], speed: 1.25 }],
               offenseRightMidfield: [{ coordinates: [{ x: -750, y: -550 }], speed: 0.75 }],
               offenseRightCenterMidfield: [{ coordinates: [{ x: -475, y: -100 }], speed: 1 }],
               offenseLeftCenterMidfield: [{ coordinates: [{ x: -475, y: 300 }], speed:1 }],
               offenseLeftMidfield: [{ coordinates: [{ x: -700, y: 650 }] , speed: 0.75}],
               offenseRightForward: [{ coordinates: [{ x: -800, y: -100 }], speed: 0.75 }],
               offenseLeftForward: [{ coordinates: [{ x: -725, y: 300 }],speed: 0.75 }],
               ball: [{ coordinates: [{x:-975, y:-125}, { x: -1000, y: -125 }, {x:-975,y:-125},{ x: -900, y: -300 }, { x: -525, y: 375 }], speed: 0.8 }],
               offenseGoalKeeper: [{ coordinates: [{ x: 950, y: 50 }], speed: 1.25 }],
               defenseGoalKeeper: [{ coordinates: [{ x: -950, y: -25 }, { x: -1000, y: -50 }, { x: -950, y: 75 }, { x: -950, y: 0 }], speed: 0.65 }],
               sidelineRef: [{ coordinates: [{ x: -500, y: -1200 }], speed: 1 }]
           },
           nextStates: [
               { state: "goalYellow4F", trigger: "offenseLeftCenterMidfield" }
           ],
           errorState: "red",
           playerWithBall: "offenseLeftCenterMidfield"
       },
       goalYellow4F: {
           moves: {
               defenseLeftBack: [{ coordinates: [{ x: -825, y: -650 }], speed: 0.75 }],
               defenseLeftCenterBack: [{ coordinates: [{ x: -800, y: -225 }], speed: 0.75 }],
               defenseRightCenterBack: [{ coordinates: [{ x: -775, y: 150 }], speed: 0.75 }],
               defenseRightBack: [{ coordinates: [{ x: -750, y: 475 }], speed: 0.75 }],
               defenseLeftMidfield: [{ coordinates: [{ x: -550, y: -500 }], speed: 0.75 }],
               defenseLeftCenterMidfield: [{ coordinates: [{ x: -625, y: -175 }], speed: 0.75 }],
               defenseRightCenterMidfield: [{ coordinates: [{ x: -550, y: 150 }], speed: 0.75 }],
               defenseRightMidfield: [{ coordinates: [{ x: -500, y: 525 }], speed: 0.75 }],
               defenseLeftForward: [{ coordinates: [{ x: -175, y: -275 }], speed: 0.75 }],
               defenseRightForward: [{ coordinates: [{ x: -175, y: 325 }], speed: 0.75 }],
               offenseRightBack: [{ coordinates: [{ x: -75, y: -675 }], speed: 0.75 }],
               offenseRightCenterBack: [{ coordinates: [{ x: 25, y: -250 }], speed: 0.75 }],
               offenseLeftCenterBack: [{ coordinates: [{ x: 50, y: 125 }], speed: 0.75 }],
               offenseLeftBack: [{ coordinates: [{ x: 25, y: 400 }], speed: 0.75 }],
               offenseRightMidfield: [{ coordinates: [{ x: -750, y: -525 }], speed: 0.75 }],
               offenseRightCenterMidfield: [{ coordinates: [{ x: -475, y: -50 }], speed: 0.75 }],
               offenseLeftCenterMidfield: [{ coordinates: [{ x: -500, y: 300 }], speed: 0.75 }],
               offenseLeftMidfield: [{ coordinates: [{ x: -675, y: 650 }], speed: 0.75 }],
               offenseRightForward: [{ coordinates: [{ x: -825, y: -100 }], speed: 0.75 }],
               offenseLeftForward: [{ coordinates: [{ x: -725, y: 275 }], speed: 0.75 }],
               ball: [{ coordinates: [{ x: -675, y: -100 }, { x: -1030, y: -500 }], speed: 0.5 }],
               offenseGoalKeeper: [{ coordinates: [{ x: 950, y: -150 }], speed: 0.75 }],
               defenseGoalKeeper: [{ coordinates: [{ x: -950, y: -250 }], speed: 0.75 }],
               sidelineRef: [{ coordinates: [{ x: -750, y: -1200 }], speed: 0.75 }]
           },
           nextStates: [
               { state: "zoomInOnGoal_DiveRight" }
           ],
           advanceOnCompletion: true,
           playerWithBall: "offenseLeftCenterMidfield"
       },
       yellow4G: {
           moves: {
               defenseLeftBack: [{ coordinates: [{ x: -700, y: -775 }], speed: 1 }],
               defenseLeftCenterBack: [{ coordinates: [{ x: -800, y: -450 }], speed: 1 }],
               defenseRightCenterBack: [{ coordinates: [{ x: -700, y: -100 }], speed: 1 }],
               defenseRightBack: [{ coordinates: [{ x: -700, y: 300 }], speed: 1 }],
               defenseLeftMidfield: [{ coordinates: [{ x: -350, y: -700 }], speed: 1 }],
               defenseLeftCenterMidfield: [{ coordinates: [{ x: -400, y: -425 }], speed: 1 }],
               defenseRightCenterMidfield: [{ coordinates: [{ x: -475, y: 50 }], speed: 1 }],
               defenseRightMidfield: [{ coordinates: [{ x: -400, y: 400 }], speed: 1 }],
               defenseLeftForward: [{ coordinates: [{ x: -50, y: -200 }], speed: 1 }],
               defenseRightForward: [{ coordinates: [{ x: -100, y: 150 }], speed: 1 }],
               offenseRightBack: [{ coordinates: [{ x: 175, y: -600 }], speed: 1 }],
               offenseRightCenterBack: [{ coordinates: [{ x: 225, y: -200 }], speed: 1 }],
               offenseLeftCenterBack: [{ coordinates: [{ x: 200, y: 100 }], speed: 1 }],
               offenseLeftBack: [{ coordinates: [{ x: 75, y: 300 }], speed: 1 }],
               offenseRightMidfield: [{ coordinates: [{ x: -550, y: -850 }], speed: 1 }],
               offenseRightCenterMidfield: [{ coordinates: [{ x: -300, y: -200 }], speed: 1 }],
               offenseLeftCenterMidfield: [{ coordinates: [{ x: -600, y: 150 }], speed: 0.75 }],
               offenseLeftMidfield: [{ coordinates: [{ x: -650, y: 550 }], speed: 1 }],
               offenseRightForward: [{ coordinates: [{ x: -700, y: -600 }], speed: 1 }],
               offenseLeftForward: [{ coordinates: [{ x: -600, y: -400 }], speed: 1 }],
               ball: [{ coordinates: [{ x: -650, y: 200 }], speed: 0.75 }],
               offenseGoalKeeper: [{ coordinates: [{ x: 950, y: 0 }], speed: 1 }],
               defenseGoalKeeper: [{ coordinates: [{ x: -950, y: 0 }], speed: 1 }],
               sidelineRef: [{ coordinates: [{ x: -500, y: -1200 }], speed: 1 }]
           },
           nextStates: [
               { state: "goalYellow4G", trigger: "offenseLeftCenterMidfield" }
           ],
           errorState: "red",
           playerWithBall: "offenseLeftCenterMidfield"
       },
       goalYellow4G: {
           moves: {
               defenseLeftBack: [{ coordinates: [{ x: -725, y: -775 }], speed: 0.25 }],
               defenseLeftCenterBack: [{ coordinates: [{ x: -825, y: -425 }], speed: 0.25 }],
               defenseRightCenterBack: [{ coordinates: [{ x: -725, y: -75 }], speed: 0.25 }],
               defenseRightBack: [{ coordinates: [{ x: -725, y: 275 }], speed: 0.25 }],
               defenseLeftMidfield: [{ coordinates: [{ x: -400, y: -675 }], speed: 0.25 }],
               defenseLeftCenterMidfield: [{ coordinates: [{ x: -450, y: -325 }], speed: 0.25 }],
               defenseRightCenterMidfield: [{ coordinates: [{ x: -525, y: 75 }], speed: 0.25 }],
               defenseRightMidfield: [{ coordinates: [{ x: -450, y: 375 }], speed: 0.25 }],
               defenseLeftForward: [{ coordinates: [{ x: -150, y: -200 }], speed: 0.25 }],
               defenseRightForward: [{ coordinates: [{ x: -150, y: 200 }], speed: 0.25 }],
               offenseRightBack: [{ coordinates: [{ x: 75, y: -575 }], speed: 0.25 }],
               offenseRightCenterBack: [{ coordinates: [{ x: 125, y: -200 }], speed: 0.25 }],
               offenseLeftCenterBack: [{ coordinates: [{ x: 100, y: 125 }], speed: 0.25 }],
               offenseLeftBack: [{ coordinates: [{ x: 25, y: 350 }], speed: 0.25 }],
               offenseRightMidfield: [{ coordinates: [{ x: -650, y: -850 }], speed: 0.25 }],
               offenseRightCenterMidfield: [{ coordinates: [{ x: -325, y: -200 }], speed: 0.25 }],
               offenseLeftCenterMidfield: [{ coordinates: [{ x: -650, y: 150 }], speed: 0.25 }],
               offenseLeftMidfield: [{ coordinates: [{ x: -675, y: 525 }], speed: 0.25 }],
               offenseRightForward: [{ coordinates: [{ x: -725, y: -575 }], speed: 0.25 }],
               offenseLeftForward: [{ coordinates: [{ x: -625, y: -350 }], speed: 0.25 }],
               ball: [{ coordinates: [{ x: -950, y: 150 }], speed: 0.25 }],
               offenseGoalKeeper: [{ coordinates: [{ x: 950, y: -150 }], speed: 0.25 }],
               defenseGoalKeeper: [{ coordinates: [{ x: -950, y: 25 }], speed: 0.25 }],
               sidelineRef: [{ coordinates: [{ x: -750, y: -1200 }], speed: 0.25 }]
           },
           nextStates: [
               { state: "zoomInOnGoal_DiveLeft" }
           ],
           advanceOnCompletion: true,
           playerWithBall: "offenseLeftCenterMidfield"
       },
       yellow4H: {
           moves: {
               defenseLeftBack: [{ coordinates: [{ x: -500, y: -700 }], speed: 1 }],
               defenseLeftCenterBack: [{ coordinates: [{ x: -850, y: -850 }], speed: 1 }],
               defenseRightCenterBack: [{ coordinates: [{ x: -800, y: -350 }], speed: 1 }],
               defenseRightBack: [{ coordinates: [{ x: -750, y: 300 }], speed: 1 }],
               defenseLeftMidfield: [{ coordinates: [{ x: -300, y: -550 }], speed: 1 }],
               defenseLeftCenterMidfield: [{ coordinates: [{ x: -450, y: -300 }], speed: 1 }],
               defenseRightCenterMidfield: [{ coordinates: [{ x: -625, y: 50 }], speed: 1 }],
               defenseRightMidfield: [{ coordinates: [{ x: -450, y: 375 }], speed: 1 }],
               defenseLeftForward: [{ coordinates: [{ x: -50, y: -200 }], speed: 1 }],
               defenseRightForward: [{ coordinates: [{ x: -100, y: 100 }], speed: 1 }],
               offenseRightBack: [{ coordinates: [{ x: 175, y: -500 }], speed: 1 }],
               offenseRightCenterBack: [{ coordinates: [{ x: 225, y: -175 }], speed: 1 }],
               offenseLeftCenterBack: [{ coordinates: [{ x: 200, y: 75 }], speed: 1 }],
               offenseLeftBack: [{ coordinates: [{ x: 175, y: 375 }], speed: 1 }],
               offenseRightMidfield: [{ coordinates: [{ x: -350, y: -750 }], speed: 1 }],
               offenseRightCenterMidfield: [{ coordinates: [{ x: -400, y: 75 }], speed: 1 }],
               offenseLeftCenterMidfield: [{ coordinates: [{ x: -750, y: 75 }], speed: 0.75 }],
               offenseLeftMidfield: [{ coordinates: [{ x: -750, y: 550 }], speed: 1 }],
               offenseRightForward: [{ coordinates: [{ x: -900, y: -1050 }], speed: 1 }],
               offenseLeftForward: [{ coordinates: [{ x: -675, y: -450 }], speed: 1 }],
               ball: [{ coordinates: [{ x: -800, y: 150 }], speed: 0.75 }],
               offenseGoalKeeper: [{ coordinates: [{ x: 950, y: -150 }], speed: 1 }],
               defenseGoalKeeper: [{ coordinates: [{ x: -950, y: 50 }], speed: 1 }],
               sidelineRef: [{ coordinates: [{ x: -650, y: -1200 }], speed: 1 }]
           },
           nextStates: [
               { state: "goalYellow4H", trigger: "offenseLeftCenterMidfield" }
           ],
           errorState: "red",
           playerWithBall: "offenseLeftCenterMidfield"
       },
       goalYellow4H: {
           moves: {
               defenseLeftBack: [{ coordinates: [{ x: -525, y: -675 }], speed: 0.25 }],
               defenseLeftCenterBack: [{ coordinates: [{ x: -850, y: -825 }], speed: 0.25 }],
               defenseRightCenterBack: [{ coordinates: [{ x: -800, y: -300 }], speed: 0.25 }],
               defenseRightBack: [{ coordinates: [{ x: -775, y: 300 }], speed: 0.25 }],
               defenseLeftMidfield: [{ coordinates: [{ x: -325, y: -550 }], speed: 0.25 }],
               defenseLeftCenterMidfield: [{ coordinates: [{ x: -475, y: -275 }], speed: 0.25 }],
               defenseRightCenterMidfield: [{ coordinates: [{ x: -650, y: 25 }], speed: 0.25 }],
               defenseRightMidfield: [{ coordinates: [{ x: -400, y: 350 }], speed: 0.25 }],
               defenseLeftForward: [{ coordinates: [{ x: -150, y: -175 }], speed: 0.25 }],
               defenseRightForward: [{ coordinates: [{ x: -200, y: 150 }], speed: 0.25 }],
               offenseRightBack: [{ coordinates: [{ x: 75, y: -475 }], speed: 0.25 }],
               offenseRightCenterBack: [{ coordinates: [{ x: 175, y: -150 }], speed: 0.25 }],
               offenseLeftCenterBack: [{ coordinates: [{ x: 100, y: 100 }], speed: 0.25 }],
               offenseLeftBack: [{ coordinates: [{ x: 75, y: 400 }], speed: 0.25 }],
               offenseRightMidfield: [{ coordinates: [{ x: -375, y: -725 }], speed: 0.25 }],
               offenseRightCenterMidfield: [{ coordinates: [{ x: -425, y: 75 }], speed: 0.25 }],
               offenseLeftCenterMidfield: [{ coordinates: [{ x: -775, y: 75 }], speed: 0.25 }],
               offenseLeftMidfield: [{ coordinates: [{ x: -775, y: 525 }], speed: 0.25 }],
               offenseRightForward: [{ coordinates: [{ x: -900, y: -1025 }], speed: 0.25 }],
               offenseLeftForward: [{ coordinates: [{ x: -700, y: -425 }], speed: 0.25 }],
               ball: [{ coordinates: [{ x: -1030, y: -450 }], speed: 0.25 }],
               offenseGoalKeeper: [{ coordinates: [{ x: 950, y: -150 }], speed: 0.25 }],
               defenseGoalKeeper: [{ coordinates: [{ x: -950, y: 0 }], speed: 0.25 }],
               sidelineRef: [{ coordinates: [{ x: -750, y: -1200 }], speed: 0.25 }]
           },
           nextStates: [
               { state: "zoomInOnGoal_DiveRight" }
           ],
           advanceOnCompletion: true,
           playerWithBall: "offenseLeftCenterMidfield"
       },
       zoomInOnGoal_DiveLeft: {
           moves: {
               goalie: [{ coordinates: [{ x: 200, y: -800 }, { x: -300, y: -800 }], speed: 1 }],
               goalViewBall: [{ coordinates: [{ x: -1200, y: 800 }, { x: -500, y: -1800 }], speed: 0.5 }, { coordinates: [{ x: -200, y: -500 }], speed: 0.5 }]
           },
           nextStates: [
               { state: "winner" }
           ],
           advanceOnCompletion: true,
           soundFX: "cheer"
       },
       zoomInOnGoal_DiveRight: {
            moves: {
                goalie: [{ coordinates: [{ x: -200, y: -800 }, { x: 300, y: -800 }], speed: 1 }],
                goalViewBall: [{ coordinates: [{ x: 1200, y: 800 }, { x: 600, y: -1800 }], speed: 0.5 }, { coordinates: [{x:300,y:-500}], speed: 0.5}]
            },
            nextStates: [
                { state: "winner" }
            ],
            advanceOnCompletion: true,
            soundFX: "cheer"
        },
        red: {

        },
        winner: {
            
        },
        availablePlaysExceeded: {
            
        }
    };

    var init = function () {
        return states;
    };

    return {
        init: init
    };

})();